import type { Addon, CartItem, EventItem, EventLocalizationLanguageData, CustomField, Ticket, TicketCheckoutData, TicketLocalizationCheckoutData, TicketLocalizationLanguageCheckoutData, vat, Totals, APIReceipt, Category, Customer, Venue, FrontpageSegment } from './types';

const now = Math.floor(Date.now() / 1000);
function randomFutureTimestamp(minDays: number, maxDays: number) {
  const days = Math.floor(Math.random() * (maxDays - minDays + 1)) + minDays;
  return now + days * 86400;
}

export const customerItem: Customer = {
  name: "Jakob-NG",
  alias: "Jakob-NG",
  address: "Gunnar Clausens vej 666",
  address2: "",
  cashflow: 0,
  city: "Viby J",
  contact: "Jakob Skovbo Sørensen",
  cookie_warning: 0,
  cookie_warning_link: null,
  cookie_warning_text: null,
  country: "Danmark",
  custom_NG_footer_description: "",
  custom_NG_footer_link: "",
  custom_css: ".event__status.event__event_time_override { color: black; }\r\n\r\n#content .events .event__tint {display: none;}",
  custom_newsletter: null,
  custom_tracking_allpages: null,
  custom_tracking_receipt: null,
  default_tz_name: "Europe/Copenhagen",
  email: "jakob@safeticket.dk",
  events_shown_at_load: 9,
  events_shown_at_more: 6,
  external_ticketsale: 1,
  favicon: null,
  fb_organizer_app_id: "1431412740419789",
  fb_pixel_events: 0,
  fb_pixel_events_id: "548366625590626",
  fb_ticketsale_app_id: "617751881618765",
  force_customer_info_button: 1,
  frontpage_type: 2,
  frontpage_layout_name: "one_featured", // Possible layout names: one_featured, side_by_side, full_list, simple_list
  frontpage_show_time: true,
  giftcards: 0,
  google_analytics_trackingid_ng: null,
  google_tag_manager_trackingid: null,
  hide_doorsale_customer_info_button: 0,
  invoice_payment: 1,
  localization: 1,
  login_link: 1,
  logo: null,
  logoFooter: null,
  newsletter: 1,
  primary_language: "da",
  promoted_in_categories: [],
  provider_info_address: null,
  provider_info_city: null,
  provider_info_name: null,
  provider_registered: "",
  saleend_countdown: true,
  show_remaining_tickets: true,
  single_sign_on_required: false,
  special_categories: 0,
  special_category_name: "specialos kategorios",
  sso_price_warning: 1,
  structured_data_description_override: "structured data description",
  structured_data_name_override: "structured data name",
  telephone: "66666666",
  ticketbuyer_can_cancel_tickets: 1,
  vat: "26 93 36 76",
  vouchercode_count_transfer: 1,
  website: "https://www.safeticket.dk/",
  zip: "8260",
};

export const eventItems: EventItem[] = [
//   {
//     id: 1,
//     info1: 'BigBand Classic med Jazzband Kolding som har en mega lang titel til en tekst som er lang osv.',
//     info2: 'Jazzband Kolding spiller musik med stemmer af Duke Ellington, Count Basie m.m. og så er dette iøvrigt en rigtig lang tekst som skal skæres af med line-clamp',
//     photo: '/images/Example_event_photos/billetshop1.jpg',
//     remarks: 'Arrangementet varer 70 minutter - uden pause.',
//     price: 750,
//     priceBefore: undefined,
//     currency: 'DKK',
//     eventtime: randomFutureTimestamp(1, 30),
//     eventtime_gmt_offset: 0,
//     eventtime_override: undefined,
//     dateRange: [randomFutureTimestamp(1, 30), randomFutureTimestamp(1, 30)],
//     organizer: 'Museum Skanderborg, Kulturskolen Skanderborg, Biblioteket og Kulturhuset',
//     few_tickets: true,
//     categories: [4, 5, 6],
//     venue: 2,
//     aggregated_categories_event_order: null,
//     aggregated_special_categories_event_order: false,
//     extra_photos: [
//       '/images/Example_event_photos/billetshop2.jpg',
//       '/images/Example_event_photos/billetshop3.jpg',
//       '/images/Example_event_photos/billetshop4.jpg',
//       '/images/Example_event_photos/billetshop5.jpg',
//       '/images/Example_event_photos/billetshop6.jpg',
//     ],
//     video_url: 'https://www.youtube.com/watch?v=dQw4w9WgXcQ',
//     remaining_tickets: 150,
//     description: `<p>Ut ultricies vestibulum lacus in semper consectetur. Donec non tellus ut enim aliquet lacinia. Aenean ac orci id elit molestudas rhoncus porttitor eget lacus. Quisque a justo tristique, congue dolor et, scelerisque velit. Mauris eget dictum pulvinar. Sed bibendum ut magna ut tincidunt. Praesent pretium ut mi elementum. Phasellus condimentum leo quis erat rhoncus, et lacinia mi dictum.</p>
//               <p> Nunc vulputate in augue eu consectetur. Vestibulum suscipit, leo vel convallis consectetur, est purus mollis magna, mattis varius vestibulum ex ante sit amet metus. Morbi sodales neque vulputate, aliquam mi non, pellentesque mi. Curabitur ullamcorper convallis eros, at porttitor ex gravida non.</p>
//               <h3>Sed vestibulum lacus in semper consectetur.</h3>
//               <p> Nunc vitae consectetur neque, id volutpat magna. Curabitur ut mollis neque. Sed consectetur erat ut eleifend accumsan. Donec vehicula odio efficitur odio fermentum, at cursus felis vehicula. Vivamus et eros purus. Integer posuere placerat aliquet.</p>
//               <h3>Aliquam ornare nisl ut odio porta tincidunt.</h3>
//               <p> Maecenas non nunc vel sem rhoncus gravida. Morbi congue, sapien nec consectetur pretium, sapien velit at diam, nec ultricies dolor orci aliquet orci. Nam posuere risus augue, sed scelerisque risus suscipit sit amet. Suspendisse potenti. Duis vel elit fermentum, laoreet velit a, rhoncus massa. Praesent tincidunt. Curabitur eu faucibus metus. Etiam gravida lorem ipsum.</p>
//               <h3> Suspendisse ultricies venenatis eros, sed tempor dui condimentum et.
//               </h3>
//               <p> Vivamus elementum pellentesque eros, id porttitor augue porta eget. Nullam pharetra rutrum viverra. Praesent egestas eget tortor et vulputate. Mauris ac mollis urna. Sed dui sapien, rhoncus ut imperdiet vel, suscipit at sem. Pellentesque sodales rutrum aliquet. Proin malesuada turpis dignissim nisi ullamcorper convallis. Morbi luctus, felis et feugiat mattis, arcu magna cursus sem, id imperdiet felis libero eu lectus.</p>`,
//     element_type: 'Jazzband Kolding spiller musik med stemmer af Duke Ellington, Count Basie m.m. og så er dette iøvrigt en rigtig lang tekst som skal skæres af med line-clamp',
//     language: 'da',
//     languages: ['da', 'en'],
//     localizations: {
//       'da': {
//         info1: 'BigBand Classic med Jazzband Kolding som har en mega lang titel til en tekst som er lang osv.',
//         info2: 'Jazzband Kolding spiller musik med stemmer af Duke Ellington, Count Basie m.m. og så er dette iøvrigt en rigtig lang tekst som skal skæres af med line-clamp',
//         remarks: 'Arrangementet varer 70 minutter - uden pause.',
//         description:  `<p>DA Ut ultricies vestibulum lacus in semper consectetur. Donec non tellus ut enim aliquet lacinia. Aenean ac orci id elit molestudas rhoncus porttitor eget lacus. Quisque a justo tristique, congue dolor et, scelerisque velit. Mauris eget dictum pulvinar. Sed bibendum ut magna ut tincidunt. Praesent pretium ut mi elementum. Phasellus condimentum leo quis erat rhoncus, et lacinia mi dictum.</p>
//               <p> Nunc vulputate in augue eu consectetur. Vestibulum suscipit, leo vel convallis consectetur, est purus mollis magna, mattis varius vestibulum ex ante sit amet metus. Morbi sodales neque vulputate, aliquam mi non, pellentesque mi. Curabitur ullamcorper convallis eros, at porttitor ex gravida non.</p>
//               <h3>Sed vestibulum lacus in semper consectetur.</h3>
//               <p> Nunc vitae consectetur neque, id volutpat magna. Curabitur ut mollis neque. Sed consectetur erat ut eleifend accumsan. Donec vehicula odio efficitur odio fermentum, at cursus felis vehicula. Vivamus et eros purus. Integer posuere placerat aliquet.</p>
//               <h3>Aliquam ornare nisl ut odio porta tincidunt.</h3>
//               <p> Maecenas non nunc vel sem rhoncus gravida. Morbi congue, sapien nec consectetur pretium, sapien velit at diam, nec ultricies dolor orci aliquet orci. Nam posuere risus augue, sed scelerisque risus suscipit sit amet. Suspendisse potenti. Duis vel elit fermentum, laoreet velit a, rhoncus massa. Praesent tincidunt. Curabitur eu faucibus metus. Etiam gravida lorem ipsum.</p>
//               <h3> Suspendisse ultricies venenatis eros, sed tempor dui condimentum et.
//               </h3>
//               <p> Vivamus elementum pellentesque eros, id porttitor augue porta eget. Nullam pharetra rutrum viverra. Praesent egestas eget tortor et vulputate. Mauris ac mollis urna. Sed dui sapien, rhoncus ut imperdiet vel, suscipit at sem. Pellentesque sodales rutrum aliquet. Proin malesuada turpis dignissim nisi ullamcorper convallis. Morbi luctus, felis et feugiat mattis, arcu magna cursus sem, id imperdiet felis libero eu lectus.</p>`,
//         price_override_text: '',
//         single_sign_on_price_override_text: '',
//       },
//       'en': {
//         info1: 'BigBand Classic with Jazzband Kolding which has a very long title for a text that is long etc.',
//         info2: 'Jazzband Kolding plays music with voices of Duke Ellington, Count Basie, etc. and this is by the way a really long text that needs to be cut off with line-clamp',
//         remarks: 'The event lasts 70 minutes - without a break.',
//         description:  `<p>EN Ut ultricies vestibulum lacus in semper consectetur. Donec non tellus ut enim aliquet lacinia. Aenean ac orci id elit molestudas rhoncus porttitor eget lacus. Quisque a justo tristique, congue dolor et, scelerisque velit. Mauris eget dictum pulvinar. Sed bibendum ut magna ut tincidunt. Praesent pretium ut mi elementum. Phasellus condimentum leo quis erat rhoncus, et lacinia mi dictum.</p>
//               <p> Nunc vulputate in augue eu consectetur. Vestibulum suscipit, leo vel convallis consectetur, est purus mollis magna, mattis varius vestibulum ex ante sit amet metus. Morbi sodales neque vulputate, aliquam mi non, pellentesque mi. Curabitur ullamcorper convallis eros, at porttitor ex gravida non.</p>
//               <h3>Sed vestibulum lacus in semper consectetur.</h3>
//               <p> Nunc vitae consectetur neque, id volutpat magna. Curabitur ut mollis neque. Sed consectetur erat ut eleifend accumsan. Donec vehicula odio efficitur odio fermentum, at cursus felis vehicula. Vivamus et eros purus. Integer posuere placerat aliquet.</p>
//               <h3>Aliquam ornare nisl ut odio porta tincidunt.</h3>
//               <p> Maecenas non nunc vel sem rhoncus gravida. Morbi congue, sapien nec consectetur pretium, sapien velit at diam, nec ultricies dolor orci aliquet orci. Nam posuere risus augue, sed scelerisque risus suscipit sit amet. Suspendisse potenti. Duis vel elit fermentum, laoreet velit a, rhoncus massa. Praesent tincidunt. Curabitur eu faucibus metus. Etiam gravida lorem ipsum.</p>
//               <h3> Suspendisse ultricies venenatis eros, sed tempor dui condimentum et.
//               </h3>
//               <p> Vivamus elementum pellentesque eros, id porttitor augue porta eget. Nullam pharetra rutrum viverra. Praesent egestas eget tortor et vulputate. Mauris ac mollis urna. Sed dui sapien, rhoncus ut imperdiet vel, suscipit at sem. Pellentesque sodales rutrum aliquet. Proin malesuada turpis dignissim nisi ullamcorper convallis. Morbi luctus, felis et feugiat mattis, arcu magna cursus sem, id imperdiet felis libero eu lectus.</p>`,
//         price_override_text: '',
//         single_sign_on_price_override_text: '',
//       }
//     },
//     price_override_active: false,
//     price_override_text: '',
//     promoted: true,
//     saleend: randomFutureTimestamp(1, 30),
//     saleend_gmt_offset: 0,
//     salestart: 0,
//     salestart_gmt_offset: 0,
//     single_sign_on_price_override_active: false,
//     single_sign_on_price_override_text: '',
//     soldout: false,
//     sort_order: 0,
//     special_categories: [],
//     sso_prices: {
//       'jpoplev':{
//         dankort_price: null,
//         price: 10220,
//       } ,
//       'jpoplevsubscriber': {
//         dankort_price: null,
//         price: 5675
//       },
//     },
//     status_message_text: '',
//     status_message_visible: false,
//     tickets: [],
//     tz_name: '',
    
//   },
//   {
//     id: 2,
//     info1: 'Fællessang med Steen Hattesen',
//     photo: '/images/Example_event_photos/billetshop2.jpg',
//     remarks: 'Fællessang for alle aldre. Varighed: 60 minutter.',
//     info2: 'Med Rumpistol i salen alle med synth og sandstem en undergrunde række mellem klassisk, jazz og elektronisk musik som skal opleves. Det er en koncert som du ikke må gå glip af. Som virkelig skal opleves.',
//     price: 750,
//     priceBefore: 650,
//     currency: 'DKK',
//     eventtime: randomFutureTimestamp(1, 30),
//     eventtime_gmt_offset: 0,
//     eventtime_override: undefined,
//     dateRange: undefined,
//     organizer: 'Aarhus Musikhus',
//     categories: [4, 2, 1],
//     venue: 3,
//     aggregated_categories_event_order: null,
//     aggregated_special_categories_event_order: false,
//     extra_photos: ['/images/Example_event_photos/billetshop1.jpg', '/images/Example_event_photos/billetshop3.jpg'],
//     video_url: 'https://www.youtube.com/watch?v=3JZ_D3ELwOQ',
//     remaining_tickets: 80,
//     description: `<p>Fællessang med Steen Hattesen byder på en hyggelig og stemningsfuld oplevelse for hele familien. Kom og syng med på kendte klassikere og nye sange.</p>
//       <ul>
//         <li>Fællesskab og glæde</li>
//         <li>Professionel pianist</li>
//         <li>Varighed: 60 minutter</li>
//       </ul>
//       <p>Alle er velkomne, uanset sangstemme!</p>`,
//     element_type: '',
//     language: 'da',
//     languages: ['da', 'en'],
//     localizations: {
//       'da': {
//         info1: 'Fællessang med Steen Hattesen',
//         info2: 'Med Rumpistol i salen alle med synth og sandstem en undergrunde række mellem klassisk, jazz og elektronisk musik som skal opleves. Det er en koncert som du ikke må gå glip af. Som virkelig skal opleves',
//         remarks: 'Fællessang for alle aldre. Varighed: 60 minutter.',
//         description: 'Med Rumpistol i salen alle med synth og sandstem en undergrunde række mellem klassisk, jazz og elektronisk musik som skal opleves. Det er en koncert som du ikke må gå glip af. Som virkelig skal opleves.',
//         price_override_text: '',
//         single_sign_on_price_override_text: '',
//       },
//       'en': {
//         info1: 'Community singing with Steen Hattesen',
//         info2: 'With Rumpistol in the hall, everyone with synth and sand voice an underground row between classical, jazz, and electronic music that must be experienced. It is a concert you must not miss. It really must be experienced.',
//         remarks: 'Community singing for all ages. Duration: 60 minutes.',
//         description: 'With Rumpistol in the hall, everyone with synth and sand voice an underground row between classical, jazz, and electronic music that must be experienced. It is a concert you must not miss. It really must be experienced.',
//         price_override_text: '',
//         single_sign_on_price_override_text: '',
//       }
//     },
//     few_tickets: true,
//     price_override_active: false,
//     price_override_text: '',
//     promoted: true,
//     saleend: randomFutureTimestamp(1, 30),
//     saleend_gmt_offset: 0,
//     salestart: 0,
//     salestart_gmt_offset: 0,
//     single_sign_on_price_override_active: true,
//     single_sign_on_price_override_text: '',
//     soldout: false,
//     sort_order: 0,
//     special_categories: [],
//     sso_prices: {},
//     status_message_text: 'Dette er en status besked',
//     status_message_visible: true,
//     tickets: [],
//     tz_name: ''
//   },
//   {
//     id: 3,
//     info1: 'Kristian Leth',
//     info2: 'Kristian Leth optræder med sine største hits og nye numre. En aften fyldt med musikalsk magi.',
//     remarks: 'Eksklusiv koncert med Kristian Leth. Varighed: 90 minutter.',
//     price: 99,
//     priceBefore: undefined,
//     currency: 'EUR',
//     eventtime: randomFutureTimestamp(1, 30),
//     eventtime_gmt_offset: 0,
//     eventtime_override: "Jakob skal nok sige til når det er tid",
//     dateRange: undefined,
//     organizer: 'Kulturhuset Skanderborg',
//     categories: [5, 6, 1],
//     venue: 4,
//     aggregated_categories_event_order: null,
//     aggregated_special_categories_event_order: false,
//     photo: '/images/Example_event_photos/billetshop3.jpg',
//     extra_photos: ['/images/Example_event_photos/billetshop1.jpg', '/images/Example_event_photos/billetshop2.jpg'],
//     video_url: 'https://www.youtube.com/watch?v=Zi_XLOBDo_Y',
//     remaining_tickets: 20,
//     description: `<p>Oplev Kristian Leth live med et repertoire spækket med både gamle og nye sange. Publikum kan forvente en nærværende og intens koncertoplevelse.</p>
//       <ul>
//         <li>Stærk vokal og nærvær</li>
//         <li>Unikke fortolkninger</li>
//         <li>90 minutters koncert</li>
//       </ul>`,
//     element_type: '',
//     language: 'da',
//     languages: ['da', 'en'],
//     localizations: {
//       'da': {
//         info1: 'Kristian Leth',
//         info2: 'Kristian Leth optræder med sine største hits og nye numre. En aften fyldt med musikalsk magi.',
//         remarks: 'Eksklusiv koncert med Kristian Leth. Varighed: 90 minutter.',
//         description: `<p>Oplev Kristian Leth live med et repertoire spækket med både gamle og nye sange. Publikum kan forvente en nærværende og intens koncertoplevelse.</p>
//       <ul>
//         <li>Stærk vokal og nærvær</li>
//         <li>Unikke fortolkninger</li>
//         <li>90 minutters koncert</li>
//       </ul>`,
//         button_text_find_tickets: 'Find muligheder',
//         button_text_buy_tickets: 'Køb muligheder',
//         ticket_info_message_text: '',
//         price_override_text: '',
//         single_sign_on_price_override_text: '',
//       },
//       'en': {
//         info1: 'Kristian Leth',
//         info2: 'Kristian Leth performs with his greatest hits and new songs. An evening filled with musical magic.',
//         remarks: 'Exclusive concert with Kristian Leth. Duration: 90 minutes.',
//         description: `<p>Experience Kristian Leth live with a repertoire filled with both old and new songs. The audience can expect an intimate and intense concert experience.</p>
//           <ul>
//             <li>Strong vocals and presence</li>
//             <li>Unique interpretations</li>
//             <li>90-minute concert</li>
//           </ul>`,
//         button_text_find_tickets: 'Find options',
//         button_text_buy_tickets: 'Buy options',
//         ticket_info_message_text: '',
//         price_override_text: '',
//         single_sign_on_price_override_text: '',
//       }
//     },
//     price_override_active: false,
//     price_override_text: '',
//     promoted: false,
//     saleend: randomFutureTimestamp(1, 30),
//     saleend_gmt_offset: 0,
//     salestart: 0,
//     salestart_gmt_offset: 0,
//     single_sign_on_price_override_active: false,
//     single_sign_on_price_override_text: '',
//     few_tickets: false,
//     soldout: false,
//     sort_order: 0,
//     special_categories: [],
//     sso_prices: {
//       'jpoplev':{
//         dankort_price: null,
//         price: 50,
//       } ,
//       'jpoplevsubscriber': {
//         dankort_price: null,
//         price: 75,
//       },
//     },
//     status_message_text: 'Anulleret pga. corona',
//     status_message_visible: true,
//     tickets: [],
//     tz_name: ''
//   },
//   {
//     id: 4,
//     info1: 'SACRED MUSIC - Rumpistol Ensemble',
//     photo: null,
//     remarks: 'Ensemblet opfører SACRED MUSIC. Varighed: 75 minutter.',
//     info2: 'Med Rumpistol i salen alle med synth og sandstem en undergrunde række mellem klassisk, jazz og elektronisk...',
//     price: 750,
//     priceBefore: undefined,
//     currency: 'DKK',
//     eventtime: randomFutureTimestamp(200, 300),
//     eventtime_gmt_offset: 0,
//     eventtime_override: undefined,
//     dateRange: undefined,
//     organizer: 'Kulturhuset Skanderborg',
//     categories: [3, 2, 4],
//     venue: 5,
//     aggregated_categories_event_order: null,
//     aggregated_special_categories_event_order: false,
//     extra_photos: ['/images/Example_event_photos/billetshop5.jpg', '/images/Example_event_photos/billetshop6.jpg', '/images/Example_event_photos/billetshop4.jpg'],
//     video_url: 'https://www.youtube.com/watch?v=9bZkp7q19f0',
//     remaining_tickets: 60,
//     description: `<p>SACRED MUSIC - Rumpistol Ensemble er en musikalsk oplevelse, der kombinerer klassisk og elektronisk musik i et unikt lydbillede.</p>
//       <ul>
//         <li>75 minutters koncert</li>
//         <li>Elektroniske og klassiske elementer</li>
//         <li>Ensemblet består af prisvindende musikere</li>
//       </ul>`,
//     element_type: '',
//     language: 'da',
//     languages: ['da', 'en'],
//     localizations: {
//       'da': {
//         info1: 'SACRED MUSIC - Rumpistol Ensemble',
//         info2: 'Ensemblet opfører SACRED MUSIC. Varighed: 75 minutter.',
//         remarks: 'Ensemblet opfører SACRED MUSIC. Varighed: 75 minutter.',
//         description: `<p>SACRED MUSIC - Rumpistol Ensemble er en musikalsk oplevelse, der kombinerer klassisk og elektronisk musik i et unikt lydbillede.</p>
//       <ul>
//         <li>75 minutters koncert</li>
//         <li>Elektroniske og klassiske elementer</li>
//         <li>Ensemblet består af prisvindende musikere</li>
//       </ul>`,
//         price_override_text: '',
//         single_sign_on_price_override_text: '',
//       },
//       'en': {
//         info1: 'SACRED MUSIC - Rumpistol Ensemble',
//         info2: 'The ensemble performs SACRED MUSIC. Duration: 75 minutes.',
//         remarks: 'The ensemble performs SACRED MUSIC. Duration: 75 minutes.',
//         description: `<p>SACRED MUSIC - Rumpistol Ensemble is a musical experience that combines classical and electronic music in a unique soundscape.</p>
//           <ul>
//             <li>75-minute concert</li>
//             <li>Electronic and classical elements</li>
//             <li>The ensemble consists of award-winning musicians</li>
//           </ul>`,
//         price_override_text: '',
//         single_sign_on_price_override_text: '',
//       }
//     },
//     price_override_active: false,
//     price_override_text: '',
//     promoted: false,
//     saleend: randomFutureTimestamp(1, 30),
//     saleend_gmt_offset: 0,
//     salestart: 0,
//     salestart_gmt_offset: 0,
//     single_sign_on_price_override_active: false,
//     single_sign_on_price_override_text: '',
//     few_tickets: false,
//     soldout: false,
//     sort_order: 0,
//     special_categories: [],
//     sso_prices: {},
//     status_message_text: '',
//     status_message_visible: false,
//     tickets: [],
//     tz_name: ''
//   },
//   {
//     id: 5,
//     info1: 'Liam Stand-up',
//     photo: null,
//     remarks: "Stand-up med Liam O'Connor. Varighed: 50 minutter.",
//     info2: "Liam O'Connor er en dansk standupkomiker.",
//     price: 750,
//     priceBefore: undefined,
//     currency: 'DKK',
//     eventtime: randomFutureTimestamp(1, 30),
//     eventtime_gmt_offset: 0,
//     eventtime_override: undefined,
//     dateRange: undefined,
//     organizer: 'Kulturhuset Skanderborg',
//     categories: [4, 2, 1],
//     venue: 1,
//     aggregated_categories_event_order: null,
//     aggregated_special_categories_event_order: false,
//     extra_photos: [],
//     remaining_tickets: 10,
//     description: `<p>Oplev Liam O'Connor levere skarpe jokes og underholdning i topklasse. En aften fyldt med grin og overraskelser.</p>
//       <ul>
//         <li>50 minutters stand-up</li>
//         <li>Dansk humor</li>
//         <li>Publikum inddrages</li>
//       </ul>`,
//     element_type: '',
//     language: 'da',
//     languages: ['da', 'en'],
//     localizations: {
//       'da': {
//         info1: 'Liam Stand-up',
//         info2: "Liam O'Connor er en dansk standupkomiker.",
//         remarks: "Stand-up med Liam O'Connor. Varighed: 50 minutter.",
//         description: `<p>Oplev Liam O'Connor levere skarpe jokes og underholdning i topklasse. En aften fyldt med grin og overraskelser.</p>
//           <ul>
//             <li>50 minutters stand-up</li>
//             <li>Dansk humor</li>
//             <li>Publikum inddrages</li>
//           </ul>`,
//         button_text_find_tickets: 'Find muligheder',
//         button_text_buy_tickets: 'Køb muligheder',
//         ticket_info_message_text: '',
//         price_override_text: 'Næsten gratis',
//         single_sign_on_price_override_text: '',
//       },
//       'en': {
//         info1: 'Liam Stand-up',
//         info2: "Liam O'Connor is a Danish stand-up comedian.",
//         remarks: "Stand-up with Liam O'Connor. Duration: 50 minutes.",
//         description: `<p>Experience Liam O'Connor delivering sharp jokes and top-class entertainment. An evening filled with laughter and surprises.</p>
//           <ul>
//             <li>50 minutes of stand-up</li>
//             <li>Danish humor</li>
//             <li>Audience participation</li>
//           </ul>`,
//         button_text_find_tickets: 'Find options',
//         button_text_buy_tickets: 'Buy options',
//         ticket_info_message_text: '',
//         price_override_text: '',
//         single_sign_on_price_override_text: '',
//       }
//     },
//     price_override_active: false,
//     price_override_text: '',
//     promoted: false,
//     saleend: randomFutureTimestamp(1, 30),
//     saleend_gmt_offset: 0,
//     salestart: 0,
//     salestart_gmt_offset: 0,
//     single_sign_on_price_override_active: false,
//     single_sign_on_price_override_text: '',
//     few_tickets: false,
//     soldout: true,
//     sort_order: 0,
//     special_categories: [],
//     sso_prices: {},
//     status_message_text: '',
//     status_message_visible: false,
//     tickets: [],
//     tz_name: ''
//   },
//   {
//     id: 6,
//     info1: 'Eventyr Venter: Udforsk Naturens Vidundere',
//     info2: 'Med Rumpistol i salen alle med synth og sandstem en undergrunde række mellem klassisk, jazz og elektronisk...',
//     remarks: 'Gentagelse af Eventyr Venter: Udforsk Naturens Vidundere. Varighed: 75 minutter.',
//     price: 750,
//     priceBefore: undefined,
//     currency: 'DKK',
//     eventtime: randomFutureTimestamp(1, 30),
//     eventtime_gmt_offset: 0,
//     eventtime_override: undefined,
//     dateRange: undefined,
//     organizer: 'Kulturhuset Skanderborg',
//     categories: [4, 2, 1],
//     venue: 5,
//     aggregated_categories_event_order: 1,
//     aggregated_special_categories_event_order: false,
//     photo: '/images/Example_event_photos/billetshop6.jpg',
//     extra_photos: ['/images/Example_event_photos/billetshop4.jpg', '/images/Example_event_photos/billetshop5.jpg'],
//     video_url: 'https://www.youtube.com/watch?v=OPf0YbXqDm0',
//     remaining_tickets: 40,
//     description: `<p>En ekstra mulighed for at opleve Eventyr Venter: Udforsk Naturens Vidundere. Musikalsk oplevelse med både klassiske og moderne elementer.</p>
//       <ul>
//         <li>75 minutters koncert</li>
//         <li>Elektroniske og klassiske elementer</li>
//         <li>Ensemblet består af prisvindende musikere</li>
//       </ul>`,
//     element_type: '',
//     language: 'da',
//     languages: ['da', 'en'],
//     localizations: {
//       'da': {
//         info1: 'Eventyr Venter: Udforsk Naturens Vidundere',
//         info2: '',
//         remarks: 'Gentagelse af SACRED MUSIC koncerten. Varighed: 75 minutter.',
//         description: 'DA Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras varius quam at dui sagittis, eu sagittis lacus vulputate. In id ex eros. Nulla dictum ac metus quis elementum. Morbi lobortis ligula eget lectus consequat, mollis dictum ligula hendrerit. Nunc aliquam orci ut pellentesque mattis. Suspendisse in ex augue. Nam quis finibus tortor, vitae lobortis nunc. Praesent blandit tortor ut ultricies consequat. Suspendisse pretium porttitor quam vitae pulvinar. Duis varius nibh nec leo finibus, sollicitudin vestibulum risus commodo. In auctor tortor leo, a egestas justo egestas volutpat.',
//         price_override_text: '',
//         single_sign_on_price_override_text: '',
//       },
//       'en': {
//         info1: 'Adventure Awaits: Explore the Wonders of Nature',
//         info2: '',
//         remarks: 'Repetition of the Eventyr Venter: Udforsk Naturens Vidundere concert. Duration: 75 minutes.',
//         description: 'EN Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras varius quam at dui sagittis, eu sagittis lacus vulputate. In id ex eros. Nulla dictum ac metus quis elementum. Morbi lobortis ligula eget lectus consequat, mollis dictum ligula hendrerit. Nunc aliquam orci ut pellentesque mattis. Suspendisse in ex augue. Nam quis finibus tortor, vitae lobortis nunc. Praesent blandit tortor ut ultricies consequat. Suspendisse pretium porttitor quam vitae pulvinar. Duis varius nibh nec leo finibus, sollicitudin vestibulum risus commodo. In auctor tortor leo, a egestas justo egestas volutpat.',
//         price_override_text: '',
//         single_sign_on_price_override_text: '',
//       }
//     },
//     price_override_active: false,
//     price_override_text: '',
//     promoted: false,
//     saleend: randomFutureTimestamp(1, 30),
//     saleend_gmt_offset: 0,
//     salestart: 0,
//     salestart_gmt_offset: 0,
//     single_sign_on_price_override_active: false,
//     single_sign_on_price_override_text: '',
//     few_tickets: false,
//     soldout: false,
//     sort_order: 0,
//     special_categories: [],
//     sso_prices: {},
//     status_message_text: '',
//     status_message_visible: false,
//     tickets: [],
//     tz_name: ''
//   },
//   {
//     id: 7,
//     info1: 'Dyrelivseventyr: En Dag i Naturen',
//     photo: '/images/Example_event_photos/billetshop7.jpg',
//     remarks: 'Afslutningskoncert for festivalen. Varighed: 75 minutter.',
//     info2: 'Med Rumpistol i salen alle med synth og sandstem en undergrunde række mellem klassisk, jazz og elektronisk...',
//     price: 750,
//     priceBefore: undefined,
//     currency: 'DKK',
//     eventtime: randomFutureTimestamp(1, 30),
//     eventtime_gmt_offset: 0,
//     eventtime_override: undefined,
//     dateRange: undefined,
//     organizer: 'Kulturhuset Skanderborg',
//     categories: [4, 2, 1],
//     venue: 2,
//     aggregated_categories_event_order: null,
//     aggregated_special_categories_event_order: false,
//     extra_photos: ['/images/Example_event_photos/billetshop4.jpg', '/images/Example_event_photos/billetshop5.jpg'],
//     video_url: 'https://www.youtube.com/watch?v=RgKAFK5djSk',
//     remaining_tickets: 30,
//     description: `<p>Festivalens afslutningskoncert med Rumpistol Ensemble. En musikalsk rejse gennem klassisk og elektronisk musik.</p>
//       <ul>
//         <li>75 minutters koncert</li>
//         <li>Elektroniske og klassiske elementer</li>
//         <li>Ensemblet består af prisvindende musikere</li>
//       </ul>`,
//     element_type: '',
//     language: 'da',
//     languages: ['da', 'en'],
//     localizations: {
//       'da': {
//         info1: 'Dyrelivseventyr: En Dag i Naturen',
//         info2: '',
//         remarks: 'Afslutningskoncert for festivalen. Varighed: 75 minutter.',
//         description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras varius quam at dui sagittis, eu sagittis lacus vulputate. In id ex eros. Nulla dictum ac metus quis elementum. Morbi lobortis ligula eget lectus consequat, mollis dictum ligula hendrerit. Nunc aliquam orci ut pellentesque mattis. Suspendisse in ex augue. Nam quis finibus tortor, vitae lobortis nunc. Praesent blandit tortor ut ultricies consequat. Suspendisse pretium porttitor quam vitae pulvinar. Duis varius nibh nec leo finibus, sollicitudin vestibulum risus commodo. In auctor tortor leo, a egestas justo egestas volutpat.',
//         price_override_text: '',
//         single_sign_on_price_override_text: '',
//       },
//       'en': {
//         info1: 'Dyrelivseventyr: A Day in Nature',
//         info2: '',
//         remarks: 'Closing concert for the festival. Duration: 75 minutes.',
//         description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras varius quam at dui sagittis, eu sagittis lacus vulputate. In id ex eros. Nulla dictum ac metus quis elementum. Morbi lobortis ligula eget lectus consequat, mollis dictum ligula hendrerit. Nunc aliquam orci ut pellentesque mattis. Suspendisse in ex augue. Nam quis finibus tortor, vitae lobortis nunc. Praesent blandit tortor ut ultricies consequat. Suspendisse pretium porttitor quam vitae pulvinar. Duis varius nibh nec leo finibus, sollicitudin vestibulum risus commodo. In auctor tortor leo, a egestas justo egestas volutpat.',
//         price_override_text: '',
//         single_sign_on_price_override_text: '',
//       }
//     },
//     price_override_active: false,
//     price_override_text: '',
//     promoted: false,
//     saleend: randomFutureTimestamp(1, 30),
//     saleend_gmt_offset: 0,
//     salestart: 0,
//     salestart_gmt_offset: 0,
//     single_sign_on_price_override_active: false,
//     single_sign_on_price_override_text: '',
//     few_tickets: false,
//     soldout: false,
//     sort_order: 0,
//     special_categories: [],
//     sso_prices: {},
//     status_message_text: '',
//     status_message_visible: false,
//     tickets: [],
//     tz_name: ''
//   },
//   {
//     id: 8,
//     info1: 'Fællessang med Steen Hattesen',
//     photo: '/images/Example_event_photos/billetshop8.jpg',
//     remarks: 'Fællessang for alle aldre. Varighed: 60 minutter.',
//     info2: 'Med Rumpistol i salen alle med synth og sandstem en undergrunde række mellem klassisk, jazz og elektronisk...',
//     price: 750,
//     priceBefore: undefined,
//     currency: 'DKK',
//     eventtime: randomFutureTimestamp(1, 30),
//     eventtime_gmt_offset: 0,
//     eventtime_override: undefined,
//     dateRange: undefined,
//     organizer: 'Kulturhuset Skanderborg',
//     categories: [4, 2, 1],
//     venue: 3,
//     aggregated_categories_event_order: null,
//     aggregated_special_categories_event_order: false,
//     extra_photos: ['/images/Example_event_photos/billetshop2.jpg', '/images/Example_event_photos/billetshop3.jpg'],
//     video_url: 'https://www.youtube.com/watch?v=2Vv-BfVoq4g',
//     remaining_tickets: 50,
//     description: `<p>Fællessang med Steen Hattesen byder på en hyggelig og stemningsfuld oplevelse for hele familien. Kom og syng med på kendte klassikere og nye sange.</p>
//       <ul>
//         <li>Fællesskab og glæde</li>
//         <li>Professionel pianist</li>
//         <li>Varighed: 60 minutter</li>
//       </ul>
//       <p>Alle er velkomne, uanset sangstemme!</p>`,
//     element_type: '',
//     language: 'da',
//     languages: ['da', 'en'],
//     localizations: {
//       'da': {
//         info1: 'Fællessang med Steen Hattesen',
//         info2: '',
//         remarks: 'Fællessang for alle aldre. Varighed: 60 minutter.',
//         description: 'Med Rumpistol i salen alle med synth og sandstem en undergrunde række mellem klassisk, jazz og elektronisk...',
//         price_override_text: '',
//         single_sign_on_price_override_text: '',
//       },
//       'en': {
//         info1: 'Community singing with Steen Hattesen',
//         info2: '',
//         remarks: 'Community singing for all ages. Duration: 60 minutes.',
//         description: 'With Rumpistol in the hall, everyone with synth and sand voice an underground row between classical, jazz, and electronic music...',
//         price_override_text: '',
//         single_sign_on_price_override_text: '',
//       }
//     },
//     price_override_active: false,
//     price_override_text: '',
//     promoted: false,
//     saleend: randomFutureTimestamp(1, 30),
//     saleend_gmt_offset: 0,
//     salestart: 0,
//     salestart_gmt_offset: 0,
//     single_sign_on_price_override_active: false,
//     single_sign_on_price_override_text: '',
//     soldout: false,
//     few_tickets: false,
//     sort_order: 0,
//     special_categories: [],
//     sso_prices: {},
//     status_message_text: '',
//     status_message_visible: false,
//     tickets: [],
//     tz_name: ''
//   },
//   {
//     id: 9,
//     info1: 'Skak for alle',
//     photo: '/images/Example_event_photos/billetshop9.jpg',
//     remarks: 'Skakturnering for alle niveauer. Varighed: 120 minutter.',
//     info2: 'Med Rumpistol i salen alle med synth og sandstem en undergrunde række mellem klassisk, jazz og elektronisk...',
//     price: 750,
//     priceBefore: undefined,
//     currency: 'DKK',
//     eventtime: randomFutureTimestamp(1, 30),
//     eventtime_gmt_offset: 0,
//     eventtime_override: undefined,
//     dateRange: undefined,
//     organizer: 'Kulturhuset Skanderborg',
//     categories: [4, 2, 1],
//     venue: 4,
//     aggregated_categories_event_order: null,
//     aggregated_special_categories_event_order: false,
//     extra_photos: ['/images/Example_event_photos/billetshop1.jpg', '/images/Example_event_photos/billetshop2.jpg'],
//     video_url: 'https://www.youtube.com/watch?v=E7wJTI-1dvQ',
//     remaining_tickets: 100,
//     description: `<p>Skak for alle er en turnering, hvor både begyndere og øvede kan deltage. Kom og oplev spændingen ved skakspillet!</p>
//       <ul>
//         <li>120 minutters turnering</li>
//         <li>Præmier til vinderne</li>
//         <li>Alle niveauer er velkomne</li>
//       </ul>`,
//     element_type: '',
//     language: 'da',
//     languages: ['da', 'en'],
//     localizations: {
//       'da': {
//         info1: 'Skak for alle',
//         info2: '',
//         remarks: 'Skakturnering for alle niveauer. Varighed: 120 minutter.',
//         description: 'Med Rumpistol i salen alle med synth og sandstem en undergrunde række mellem klassisk, jazz og elektronisk...',
//         price_override_text: '',
//         single_sign_on_price_override_text: '',
//       },
//       'en': {
//         info1: 'Chess for everyone',
//         info2: '',
//         remarks: 'Chess tournament for all levels. Duration: 120 minutes.',
//         description: 'With Rumpistol in the hall, everyone with synth and sand voice an underground row between classical, jazz, and electronic music...',
//         price_override_text: '',
//         single_sign_on_price_override_text: '',
//       }
//     },
//     price_override_active: false,
//     price_override_text: '',
//     promoted: false,
//     saleend: randomFutureTimestamp(1, 30),
//     saleend_gmt_offset: 0,
//     salestart: 0,
//     salestart_gmt_offset: 0,
//     single_sign_on_price_override_active: false,
//     single_sign_on_price_override_text: '',
//     soldout: false,
//     few_tickets: false,
//     sort_order: 0,
//     special_categories: [],
//     sso_prices: {},
//     status_message_text: '',
//     status_message_visible: false,
//     tickets: [],
//     tz_name: ''
//   },
//   {
//     id: 10,
//     info1: '6K Social Run med MK Running i København (skjult på forsiden)',
//     info2: 'Ekstra', // required
//     photo: '/images/Example_event_photos/cover.jpg',
//     remarks: '', // optional
//     price: 200,
//     priceBefore: undefined,
//     currency: 'DKK',
//     eventtime: 1782631800,
//     eventtime_gmt_offset: 0,
//     eventtime_override: undefined,
//     dateRange: undefined,
//     organizer: 'CopenHill',
//     extra_photos: ['/images/Example_event_photos/billetshop1.jpg', '/images/Example_event_photos/billetshop2.jpg'],
//     video_url: undefined,
//     remaining_tickets: 10,
//     description: undefined,
//     venue: 1,
//     aggregated_categories_event_order: null,
//     aggregated_special_categories_event_order: false,
//     categories: [1, 2, 3],
//     doorsale_button: false,
//     doorsale_soldout: false,
//     element_type: 'event',
//     external_ticketsale_price: undefined,
//     external_ticketsale_soldout: false,
//     external_ticketsale_url: undefined,
//     frontpage_event_highlight_in_calendar: false,
//     frontpage_event_text_desktop_categories: false,
//     frontpage_event_text_desktop_date: false,
//     frontpage_event_text_desktop_event_name: false,
//     frontpage_event_text_desktop_few_tickets: false,
//     frontpage_event_text_desktop_soldout: false,
//     frontpage_event_text_desktop_venue: false,
//     frontpage_event_text_mobile_categories: false,
//     frontpage_event_text_mobile_date: false,
//     frontpage_event_text_mobile_event_name: false,
//     frontpage_event_text_mobile_few_tickets: false,
//     frontpage_event_text_mobile_soldout: false,
//     frontpage_event_text_mobile_venue: false,
//     hidden_on_frontpage: true,
//     language: 'da',
//     languages: ['da'],
//     localizations: {
//       'da': {
//         info1: "6K Social Run med MK Running i København (skjult på forsiden)",
//         info2: "Ekstra",
//         remarks: "",
//         description: "",
//         price_override_text: "",
//         single_sign_on_price_override_text: "",
//       },
//       'en': {
//         info1: "6K Social Run with MK Running in Copenhagen (hidden on the front page)",
//         info2: "Extra",
//         remarks: "",
//         description: "",
//         price_override_text: "",
//         single_sign_on_price_override_text: "",
//       }
//     },
//     price_override_active: false,
//     price_override_text: '',
//     promoted: false,
//     saleend: randomFutureTimestamp(1, 30),
//     saleend_gmt_offset: 0,
//     salestart: 0,
//     salestart_gmt_offset: 0,
//     single_sign_on_price_override_active: false,
//     single_sign_on_price_override_text: '',
//     few_tickets: false,
//     soldout: false,
//     sort_order: 0,
//     special_categories: [],
//     sso_prices: {},
//     status_message_text: '',
//     status_message_visible: false,
//     tickets: [],
//     tz_name: '',
//   }
];

export const moreEventItems: EventItem[] = [
//   {
//     id: 11,
//     info1: 'Eventyr Venter: Udforsk Naturens Vidundere',
//     info2: 'MORE Tag med på en rejse fyldt med eventyr og naturoplevelser til vores eksklusive udendørs event', // required
//     photo: '/images/Example_event_photos/cover.jpg',
//     remarks: '', // optional
//     description: `<p>Ut ultricies vestibulum lacus in semper consectetur. Donec non tellus ut enim aliquet lacinia. Aenean ac orci id elit molestudas rhoncus porttitor eget lacus. Quisque a justo tristique, congue dolor et, scelerisque velit. Mauris eget dictum pulvinar. Sed bibendum ut magna ut tincidunt. Praesent pretium ut mi elementum. Phasellus condimentum leo quis erat rhoncus, et lacinia mi dictum.</p>
//               <p> Nunc vulputate in augue eu consectetur. Vestibulum suscipit, leo vel convallis consectetur, est purus mollis magna, mattis varius vestibulum ex ante sit amet metus. Morbi sodales neque vulputate, aliquam mi non, pellentesque mi. Curabitur ullamcorper convallis eros, at porttitor ex gravida non.</p>
//               <h3>Sed vestibulum lacus in semper consectetur.</h3>
//               <p> Nunc vitae consectetur neque, id volutpat magna. Curabitur ut mollis neque. Sed consectetur erat ut eleifend accumsan. Donec vehicula odio efficitur odio fermentum, at cursus felis vehicula. Vivamus et eros purus. Integer posuere placerat aliquet.</p>
//               <h3>Aliquam ornare nisl ut odio porta tincidunt.</h3>
//               <p> Maecenas non nunc vel sem rhoncus gravida. Morbi congue, sapien nec consectetur pretium, sapien velit at diam, nec ultricies dolor orci aliquet orci. Nam posuere risus augue, sed scelerisque risus suscipit sit amet. Suspendisse potenti. Duis vel elit fermentum, laoreet velit a, rhoncus massa. Praesent tincidunt. Curabitur eu faucibus metus. Etiam gravida lorem ipsum.</p>
//               <h3> Suspendisse ultricies venenatis eros, sed tempor dui condimentum et.
//               </h3>
//               <p> Vivamus elementum pellentesque eros, id porttitor augue porta eget. Nullam pharetra rutrum viverra. Praesent egestas eget tortor et vulputate. Mauris ac mollis urna. Sed dui sapien, rhoncus ut imperdiet vel, suscipit at sem. Pellentesque sodales rutrum aliquet. Proin malesuada turpis dignissim nisi ullamcorper convallis. Morbi luctus, felis et feugiat mattis, arcu magna cursus sem, id imperdiet felis libero eu lectus.</p>`,
//     price: 200,
//     currency: 'DKK',
//     eventtime: 1782631800,
//     eventtime_gmt_offset: 0,
//     eventtime_override: undefined,
//     dateRange: undefined,
//     organizer: 'CopenHill',
//     extra_photos: ['/images/Example_event_photos/billetshop1.jpg', '/images/Example_event_photos/billetshop2.jpg'],
//     video_url: undefined,
//     remaining_tickets: 10,
//     venue: 1,
//     aggregated_categories_event_order: null,
//     aggregated_special_categories_event_order: false,
//     categories: [1, 2, 3],
//     doorsale_button: false,
//     doorsale_soldout: false,
//     element_type: 'event',
//     external_ticketsale_price: undefined,
//     external_ticketsale_soldout: false,
//     external_ticketsale_url: undefined,
//     frontpage_event_highlight_in_calendar: false,
//     frontpage_event_text_desktop_categories: false,
//     frontpage_event_text_desktop_date: false,
//     frontpage_event_text_desktop_event_name: false,
//     frontpage_event_text_desktop_few_tickets: false,
//     frontpage_event_text_desktop_soldout: false,
//     frontpage_event_text_desktop_venue: false,
//     frontpage_event_text_mobile_categories: false,
//     frontpage_event_text_mobile_date: false,
//     frontpage_event_text_mobile_event_name: false,
//     frontpage_event_text_mobile_few_tickets: false,
//     frontpage_event_text_mobile_soldout: false,
//     frontpage_event_text_mobile_venue: false,
//     hidden_on_frontpage: false,
//     language: 'da',
//     languages: ['da'],
//     localizations: {
//       'da': {
//         info1: "Eventyr Venter: Udforsk Naturens Vidundere",
//         info2: "MORE Tag med på en rejse fyldt med eventyr og naturoplevelser til vores eksklusive udendørs event",
//         remarks: "",
//         description: `<p>DA Ut ultricies vestibulum lacus in semper consectetur. Donec non tellus ut enim aliquet lacinia. Aenean ac orci id elit molestudas rhoncus porttitor eget lacus. Quisque a justo tristique, congue dolor et, scelerisque velit. Mauris eget dictum pulvinar. Sed bibendum ut magna ut tincidunt. Praesent pretium ut mi elementum. Phasellus condimentum leo quis erat rhoncus, et lacinia mi dictum.</p>
//                   <p> Nunc vulputate in augue eu consectetur. Vestibulum suscipit, leo vel convallis consectetur, est purus mollis magna, mattis varius vestibulum ex ante sit amet metus. Morbi sodales neque vulputate, aliquam mi non, pellentesque mi. Curabitur ullamcorper convallis eros, at porttitor ex gravida non.</p>
//                   <h3>Sed vestibulum lacus in semper consectetur.</h3>
//                   <p> Nunc vitae consectetur neque, id volutpat magna. Curabitur ut mollis neque. Sed consectetur erat ut eleifend accumsan. Donec vehicula odio efficitur odio fermentum, at cursus felis vehicula. Vivamus et eros purus. Integer posuere placerat aliquet.</p>
//                   <h3>Aliquam ornare nisl ut odio porta tincidunt.</h3>
//                   <p> Maecenas non nunc vel sem rhoncus gravida. Morbi congue, sapien nec consectetur pretium, sapien velit at diam, nec ultricies dolor orci aliquet orci. Nam posuere risus augue, sed scelerisque risus suscipit sit amet. Suspendisse potenti. Duis vel elit fermentum, laoreet velit a, rhoncus massa. Praesent tincidunt. Curabitur eu faucibus metus. Etiam gravida lorem ipsum.</p>
//                   <h3> Suspendisse ultricies venenatis eros, sed tempor dui condimentum et.
//                   </h3>
//                   <p> Vivamus elementum pellentesque eros, id porttitor augue porta eget. Nullam pharetra rutrum viverra. Praesent egestas eget tortor et vulputate. Mauris ac mollis urna. Sed dui sapien, rhoncus ut imperdiet vel, suscipit at sem. Pellentesque sodales rutrum aliquet. Proin malesuada turpis dignissim nisi ullamcorper convallis. Morbi luctus, felis et feugiat mattis, arcu magna cursus sem, id imperdiet felis libero eu lectus.</p>`,
//         price_override_text: "",
//         single_sign_on_price_override_text: "",
//       },
//       'en': {
//         info1: "Adventure Awaits: Explore the Great Outdoors",
//         info2: "MORE Embark on a journey of discovery and adventure with our exclusive outdoor travel event",
//         remarks: "",
//         description: `<p>EN Ut ultricies vestibulum lacus in semper consectetur. Donec non tellus ut enim aliquet lacinia. Aenean ac orci id elit molestudas rhoncus porttitor eget lacus. Quisque a justo tristique, congue dolor et, scelerisque velit. Mauris eget dictum pulvinar. Sed bibendum ut magna ut tincidunt. Praesent pretium ut mi elementum. Phasellus condimentum leo quis erat rhoncus, et lacinia mi dictum.</p>
//                   <p> Nunc vulputate in augue eu consectetur. Vestibulum suscipit, leo vel convallis consectetur, est purus mollis magna, mattis varius vestibulum ex ante sit amet metus. Morbi sodales neque vulputate, aliquam mi non, pellentesque mi. Curabitur ullamcorper convallis eros, at porttitor ex gravida non.</p>
//                   <h3>Sed vestibulum lacus in semper consectetur.</h3>
//                   <p> Nunc vitae consectetur neque, id volutpat magna. Curabitur ut mollis neque. Sed consectetur erat ut eleifend accumsan. Donec vehicula odio efficitur odio fermentum, at cursus felis vehicula. Vivamus et eros purus. Integer posuere placerat aliquet.</p>
//                   <h3>Aliquam ornare nisl ut odio porta tincidunt.</h3>
//                   <p> Maecenas non nunc vel sem rhoncus gravida. Morbi congue, sapien nec consectetur pretium, sapien velit at diam, nec ultricies dolor orci aliquet orci. Nam posuere risus augue, sed scelerisque risus suscipit sit amet. Suspendisse potenti. Duis vel elit fermentum, laoreet velit a, rhoncus massa. Praesent tincidunt. Curabitur eu faucibus metus. Etiam gravida lorem ipsum.</p>
//                   <h3> Suspendisse ultricies venenatis eros, sed tempor dui condimentum et.
//                   </h3>
//                   <p> Vivamus elementum pellentesque eros, id porttitor augue porta eget. Nullam pharetra rutrum viverra. Praesent egestas eget tortor et vulputate. Mauris ac mollis urna. Sed dui sapien, rhoncus ut imperdiet vel, suscipit at sem. Pellentesque sodales rutrum aliquet. Proin malesuada turpis dignissim nisi ullamcorper convallis. Morbi luctus, felis et feugiat mattis, arcu magna cursus sem, id imperdiet felis libero eu lectus.</p>`,
//         price_override_text: "",
//         single_sign_on_price_override_text: "",
//       }
//     },
//     price_override_active: false,
//     price_override_text: '',
//     promoted: false,
//     saleend: randomFutureTimestamp(31, 60),
//     saleend_gmt_offset: 0,
//     salestart: randomFutureTimestamp(1, 30),
//     salestart_gmt_offset: 0,
//     single_sign_on_price_override_active: false,
//     single_sign_on_price_override_text: '',
//     few_tickets: false,
//     soldout: false,
//     sort_order: 0,
//     special_categories: [],
//     sso_prices: {},
//     status_message_text: '',
//     status_message_visible: false,
//     tickets: [],
//     tz_name: '',
//   },
//   {
//     id: 12,
//     info1: 'Dyrelivseventyr: En Dag i Naturen',
//     info2: 'MORE Oplev naturens magi med en dag fyldt med dyremøder og udendørs sjov for hele familien', // required
//     photo: '/images/Example_event_photos/billetshop1.jpg',
//     remarks: 'Arrangementet varer 70 minutter - uden pause.',
//     price: 750,
//     priceBefore: undefined,
//     currency: 'DKK',
//     eventtime: randomFutureTimestamp(1, 30),
//     eventtime_gmt_offset: 0,
//     eventtime_override: undefined,
//     dateRange: [randomFutureTimestamp(1, 30), randomFutureTimestamp(1, 30)],
//     organizer: 'Museum Skanderborg, Kulturskolen Skanderborg, Biblioteket og Kulturhuset',
//     categories: [4, 5, 6],
//     venue: 2,
//     aggregated_categories_event_order: null,
//     aggregated_special_categories_event_order: false,
//     extra_photos: [
//       '/images/Example_event_photos/billetshop2.jpg',
//       '/images/Example_event_photos/billetshop3.jpg',
//       '/images/Example_event_photos/billetshop4.jpg',
//       '/images/Example_event_photos/billetshop5.jpg',
//       '/images/Example_event_photos/billetshop6.jpg',
//     ],
//     video_url: 'https://www.youtube.com/watch?v=dQw4w9WgXcQ',
//     remaining_tickets: 150,
//     description: `<p>Ut ultricies vestibulum lacus in semper consectetur. Donec non tellus ut enim aliquet lacinia. Aenean ac orci id elit molestudas rhoncus porttitor eget lacus. Quisque a justo tristique, congue dolor et, scelerisque velit. Mauris eget dictum pulvinar. Sed bibendum ut magna ut tincidunt. Praesent pretium ut mi elementum. Phasellus condimentum leo quis erat rhoncus, et lacinia mi dictum.</p>
//               <p> Nunc vulputate in augue eu consectetur. Vestibulum suscipit, leo vel convallis consectetur, est purus mollis magna, mattis varius vestibulum ex ante sit amet metus. Morbi sodales neque vulputate, aliquam mi non, pellentesque mi. Curabitur ullamcorper convallis eros, at porttitor ex gravida non.</p>
//               <h3>Sed vestibulum lacus in semper consectetur.</h3>
//               <p> Nunc vitae consectetur neque, id volutpat magna. Curabitur ut mollis neque. Sed consectetur erat ut eleifend accumsan. Donec vehicula odio efficitur odio fermentum, at cursus felis vehicula. Vivamus et eros purus. Integer posuere placerat aliquet.</p>
//               <h3>Aliquam ornare nisl ut odio porta tincidunt.</h3>
//               <p> Maecenas non nunc vel sem rhoncus gravida. Morbi congue, sapien nec consectetur pretium, sapien velit at diam, nec ultricies dolor orci aliquet orci. Nam posuere risus augue, sed scelerisque risus suscipit sit amet. Suspendisse potenti. Duis vel elit fermentum, laoreet velit a, rhoncus massa. Praesent tincidunt. Curabitur eu faucibus metus. Etiam gravida lorem ipsum.</p>
//               <h3> Suspendisse ultricies venenatis eros, sed tempor dui condimentum et.
//               </h3>
//               <p> Vivamus elementum pellentesque eros, id porttitor augue porta eget. Nullam pharetra rutrum viverra. Praesent egestas eget tortor et vulputate. Mauris ac mollis urna. Sed dui sapien, rhoncus ut imperdiet vel, suscipit at sem. Pellentesque sodales rutrum aliquet. Proin malesuada turpis dignissim nisi ullamcorper convallis. Morbi luctus, felis et feugiat mattis, arcu magna cursus sem, id imperdiet felis libero eu lectus.</p>`,
//     element_type: '',
//     language: 'da',
//     languages: ['da', 'en'],
//     localizations: {
//       'da': {
//         info1: 'Dyrelivseventyr: En Dag i Naturen',
//         info2: 'MORE Oplev naturens magi med en dag fyldt med dyremøder og udendørs sjov for hele familien',
//         remarks: 'Arrangementet varer 70 minutter - uden pause.',
//         description: 'Jazzband Kolding spiller musik med stemmer af Duke Ellington, Count Basie m.m. og så er dette iøvrigt en rigtig lang tekst som skal skæres af med line-clamp',
//         price_override_text: '',
//         single_sign_on_price_override_text: '',
//       },
//       'en': {
//         info1: 'Wildlife Adventure: A Day in Nature',
//         info2: 'MORE Experience the thrill of the wild with a day full of animal encounters and outdoor fun for the whole family!',
//         remarks: 'The event lasts 70 minutes - without a break.',
//         description: 'Jazzband Kolding plays music with voices of Duke Ellington, Count Basie, etc., and this is also a really long text that needs to be truncated with line-clamp.',
//         price_override_text: '',
//         single_sign_on_price_override_text: '',
//       }
//     },
//     price_override_active: false,
//     price_override_text: '',
//     promoted: false,
//     saleend: randomFutureTimestamp(1, 30),
//     saleend_gmt_offset: 0,
//     salestart: 0,
//     salestart_gmt_offset: 0,
//     single_sign_on_price_override_active: false,
//     single_sign_on_price_override_text: '',
//     few_tickets: false,
//     soldout: false,
//     sort_order: 0,
//     special_categories: [],
//     sso_prices: {},
//     status_message_text: '',
//     status_message_visible: false,
//     tickets: [],
//     tz_name: ''
//   },
//   {
//     id: 13,
//     info1: 'Symfoni af Ord: En Aften med Musik og Litteratur',
//     info2: 'MORE Oplev den perfekte harmoni mellem levende musik og fængslende litteratur i en uforglemmelig aften', // required
//     photo: '/images/Example_event_photos/billetshop2.jpg',
//     remarks: 'Fællessang for alle aldre. Varighed: 60 minutter.',
//     price: 750,
//     priceBefore: 650,
//     currency: 'DKK',
//     eventtime: randomFutureTimestamp(1, 30),
//     eventtime_gmt_offset: 0,
//     eventtime_override: undefined,
//     dateRange: undefined,
//     organizer: 'Aarhus Musikhus',
//     categories: [4, 2, 1],
//     venue: 3,
//     aggregated_categories_event_order: null,
//     aggregated_special_categories_event_order: false,
//     extra_photos: ['/images/Example_event_photos/billetshop1.jpg', '/images/Example_event_photos/billetshop3.jpg'],
//     video_url: 'https://www.youtube.com/watch?v=3JZ_D3ELwOQ',
//     remaining_tickets: 80,
//     description: `<p>Fællessang med Steen Hattesen byder på en hyggelig og stemningsfuld oplevelse for hele familien. Kom og syng med på kendte klassikere og nye sange.</p>
//       <ul>
//         <li>Fællesskab og glæde</li>
//         <li>Professionel pianist</li>
//         <li>Varighed: 60 minutter</li>
//       </ul>
//       <p>Alle er velkomne, uanset sangstemme!</p>`,
//     element_type: '',
//     language: 'da',
//     languages: ['da', 'en'],
//     localizations: {
//       'da': {
//         info1: 'Symfoni af Ord: En Aften med Musik og Litteratur',
//         info2: 'MORE Oplev den perfekte harmoni mellem levende musik og fængslende litteratur i en uforglemmelig aften',
//         remarks: 'Fællessang for alle aldre. Varighed: 60 minutter.',
//         description: 'Med Rumpistol i salen alle med synth og sandstem en undergrunde række mellem klassisk, jazz og elektronisk musik som skal opleves. Det er en koncert som du ikke må gå glip af. Som virkelig skal opleves.',
//         price_override_text: '',
//         single_sign_on_price_override_text: '',
//       },
//       'en': {
//         info1: 'Symphony of Words: A Night of Music and Literature',
//         info2: 'MORE Experience the perfect harmony of live music and captivating literature in an unforgettable evening',
//         remarks: 'Community singing for all ages. Duration: 60 minutes.',
//         description: 'With Rumpistol in the hall, everyone with synth and sand voice an underground row between classical, jazz, and electronic music that must be experienced. It is a concert you must not miss. It really must be experienced.',
//         price_override_text: '',
//         single_sign_on_price_override_text: '',
//       }
//     },
//     price_override_active: false,
//     price_override_text: '',
//     promoted: false,
//     saleend: randomFutureTimestamp(1, 30),
//     saleend_gmt_offset: 0,
//     salestart: 0,
//     salestart_gmt_offset: 0,
//     single_sign_on_price_override_active: false,
//     single_sign_on_price_override_text: '',
//     few_tickets: false,
//     soldout: false,
//     sort_order: 0,
//     special_categories: [],
//     sso_prices: {},
//     status_message_text: '',
//     status_message_visible: false,
//     tickets: [],
//     tz_name: ''
//   },
//   {
//     id: 14,
//     info1: 'Harmoni af Ord og Melodi',
//     info2: 'MORE Oplev en fortryllende aften, hvor litteratur møder musik og sang i en symfoni af kunst', // required
//     photo: '/images/Example_event_photos/billetshop3.jpg',
//     remarks: 'Eksklusiv koncert med Kristian Leth. Varighed: 90 minutter.',
//     price: 99,
//     priceBefore: undefined,
//     currency: 'EUR',
//     eventtime: randomFutureTimestamp(1, 30),
//     eventtime_gmt_offset: 0,
//     eventtime_override: undefined,
//     dateRange: undefined,
//     organizer: 'Kulturhuset Skanderborg',
//     categories: [5, 6, 1],
//     venue: 4,
//     aggregated_categories_event_order: null,
//     aggregated_special_categories_event_order: false,
//     extra_photos: ['/images/Example_event_photos/billetshop1.jpg', '/images/Example_event_photos/billetshop2.jpg'],
//     video_url: 'https://www.youtube.com/watch?v=Zi_XLOBDo_Y',
//     remaining_tickets: 20,
//     description: `<p>Oplev Kristian Leth live med et repertoire spækket med både gamle og nye sange. Publikum kan forvente en nærværende og intens koncertoplevelse.</p>
//       <ul>
//         <li>Stærk vokal og nærvær</li>
//         <li>Unikke fortolkninger</li>
//         <li>90 minutters koncert</li>
//       </ul>`,
//     element_type: '',
//     language: 'da',
//     languages: ['da', 'en'],
//     localizations: {
//       'da': {
//         info1: 'Harmoni af Ord og Melodi',
//         info2: 'MORE Oplev en fortryllende aften, hvor litteratur møder musik og sang i en symfoni af kunst',
//         remarks: 'Eksklusiv koncert med Kristian Leth. Varighed: 90 minutter.',
//         description: 'Kristian Leth optræder med sine største hits og nye numre. En aften fyldt med musikalsk magi.',
//         price_override_text: '',
//         single_sign_on_price_override_text: '',
//       },
//       'en': {
//         info1: 'Harmony of Words and Melody',
//         info2: 'MORE Experience an enchanting evening where literature meets music and song, creating a symphony of art',
//         remarks: 'Exclusive concert with Kristian Leth. Duration: 90 minutes.',
//         description: 'Kristian Leth performs with his greatest hits and new songs. An evening filled with musical magic.',
//         price_override_text: '',
//         single_sign_on_price_override_text: '',
//       }
//     },
//     price_override_active: false,
//     price_override_text: '',
//     promoted: false,
//     saleend: randomFutureTimestamp(1, 30),
//     saleend_gmt_offset: 0,
//     salestart: 0,
//     salestart_gmt_offset: 0,
//     single_sign_on_price_override_active: false,
//     single_sign_on_price_override_text: '',
//     few_tickets: false,
//     soldout: false,
//     sort_order: 0,
//     special_categories: [],
//     sso_prices: {},
//     status_message_text: '',
//     status_message_visible: false,
//     tickets: [],
//     tz_name: ''
//   },
//   {
//     id: 15,
//     info1: 'Dyrenes Melodier',
//     info2: 'MORE Oplev naturens harmoni og musik i en uforglemmelig aften med dyreinspirerede melodier', // required
//     photo: '/images/Example_event_photos/billetshop4.jpg',
//     remarks: 'Ensemblet opfører SACRED MUSIC. Varighed: 75 minutter.',
//     price: 750,
//     priceBefore: undefined,
//     currency: 'DKK',
//     eventtime: randomFutureTimestamp(1, 30),
//     eventtime_gmt_offset: 0,
//     eventtime_override: undefined,
//     dateRange: undefined,
//     organizer: 'Kulturhuset Skanderborg',
//     categories: [3, 2, 4],
//     venue: 5,
//     aggregated_categories_event_order: null,
//     aggregated_special_categories_event_order: false,
//     extra_photos: ['/images/Example_event_photos/billetshop5.jpg', '/images/Example_event_photos/billetshop6.jpg'],
//     video_url: 'https://www.youtube.com/watch?v=9bZkp7q19f0',
//     remaining_tickets: 60,
//     description: `<p>Dyrenes Melodier er en musikalsk oplevelse, der kombinerer klassisk og elektronisk musik i et unikt lydbillede.</p>
//       <ul>
//         <li>75 minutters koncert</li>
//         <li>Elektroniske og klassiske elementer</li>
//         <li>Ensemblet består af prisvindende musikere</li>
//       </ul>`,
//     element_type: '',
//     language: 'da',
//     languages: ['da', 'en'],
//     localizations: {
//       'da': {
//         info1: 'Dyrenes Melodier',
//         info2: 'MORE Oplev naturens harmoni og musik i en uforglemmelig aften med dyreinspirerede melodier',
//         remarks: 'Ensemblet opfører Dyrenes Melodier. Varighed: 75 minutter.',
//         description: "Kom med til en magisk aften, hvor dyrenes skønhed møder musikkens og sangens kraft. 'Dyrenes Melodier' er et unikt arrangement, der kombinerer liveoptrædener af talentfulde musikere med fantastiske billeder af dyrelivet. Fra junglens brøl til fuglenes kvidren – hver tone er inspireret af naturens lyde. Dette familievenlige event byder på interaktive indslag, hvor børn kan lære om dyr og deres levesteder. Syng med på dyretema-sange og nyd en aften fyldt med glæde, læring og underholdning. Perfekt for dyreelskere og musikentusiaster – denne oplevelse bliver en symfoni af naturen. Gå ikke glip af denne enestående begivenhed!",
//         price_override_text: '',
//         single_sign_on_price_override_text: '',
//       },
//       'en': {
//         info1: 'Melodies of the Wild',
//         info2: 'MORE Experience the harmony of nature and music in an unforgettable evening of animal-inspired melodies',
//         remarks: 'The ensemble performs SACRED MUSIC. Duration: 75 minutes.',
//         description: "Join us for a magical evening where the beauty of the animal kingdom meets the power of music and song. 'Melodies of the Wild' is a unique event that combines live performances by talented musicians with stunning visuals of wildlife. From the roar of the jungle to the chirping of birds, every note is inspired by the sounds of nature. This family-friendly event will feature interactive segments, where children can learn about animals and their habitats. Sing along to animal-themed songs and enjoy a night filled with joy, learning, and entertainment. Perfect for animal lovers and music enthusiasts alike, this event promises to be a symphony of the wild. Don't miss out on this one-of-a-kind experience!",
//         price_override_text: '',
//         single_sign_on_price_override_text: '',
//       }
//     },
//     price_override_active: false,
//     price_override_text: '',
//     promoted: false,
//     saleend: randomFutureTimestamp(1, 30),
//     saleend_gmt_offset: 0,
//     salestart: 0,
//     salestart_gmt_offset: 0,
//     single_sign_on_price_override_active: false,
//     single_sign_on_price_override_text: '',
//     few_tickets: false,
//     soldout: false,
//     sort_order: 0,
//     special_categories: [],
//     sso_prices: {},
//     status_message_text: '',
//     status_message_visible: false,
//     tickets: [],
//     tz_name: ''
//   },
//   {
//     id: 16,
//     info1: 'Melodier på Rejse',
//     info2: 'MORE Melodier på Rejse', 
//     photo: '/images/Example_event_photos/billetshop5.jpg',
//     remarks: "Stand-up med Liam O'Connor. Varighed: 50 minutter.",
//     price: 750,
//     priceBefore: undefined,
//     currency: 'DKK',
//     eventtime: randomFutureTimestamp(1, 30),
//     eventtime_gmt_offset: 0,
//     eventtime_override: undefined,
//     dateRange: undefined,
//     organizer: 'Kulturhuset Skanderborg',
//     categories: [4, 2, 1],
//     venue: 1,
//     aggregated_categories_event_order: null,
//     aggregated_special_categories_event_order: false,
//     extra_photos: ['/images/Example_event_photos/billetshop1.jpg', '/images/Example_event_photos/billetshop2.jpg'],
//     video_url: 'https://www.youtube.com/watch?v=V-_O7nl0Ii0',
//     remaining_tickets: 10,
//     description: `<p>Oplev Liam O'Connor levere skarpe jokes og underholdning i topklasse. En aften fyldt med grin og overraskelser.</p>
//       <ul>
//         <li>50 minutters stand-up</li>
//         <li>Dansk humor</li>
//         <li>Publikum inddrages</li>
//         <li>Oplev en uforglemmelig aften, hvor musik og eventyr smelter sammen. \"Melodier på Rejse\" samler verdensklasse musikere og sangere for at fejre rejsens ånd gennem sang. Fra New Yorks travle gader til Kyotos rolige landskaber – oplev en symfoni af kulturer og lyde. Lad melodierne tage dig til fjerne lande og vække din rejselyst og kærlighed til musik. Arrangementet er perfekt for rejsende, musikelskere og alle, der søger inspiration. Nyd liveoptrædener, interaktive sessioner og en livlig atmosfære. Gå ikke glip af denne unikke fejring af musik og rejser. Book dine billetter nu, og lad rejsen begynde!.</li>
//       </ul>`,
//     element_type: '',
//     language: 'da',
//     languages: ['da', 'en'],
//     localizations: {
//       'da': {
//         info1: 'Melodier på Rejse',
//         info2: 'MORE Tag med på en musikalsk rejse, hvor rytmerne fra verden møder sangens harmoni',
//         remarks: "Stand-up med Liam O'Connor. Varighed: 50 minutter.",
//         description: "Oplev en uforglemmelig aften, hvor musik og eventyr smelter sammen. \"Melodier på Rejse\" samler verdensklasse musikere og sangere for at fejre rejsens ånd gennem sang. Fra New Yorks travle gader til Kyotos rolige landskaber – oplev en symfoni af kulturer og lyde. Lad melodierne tage dig til fjerne lande og vække din rejselyst og kærlighed til musik. Arrangementet er perfekt for rejsende, musikelskere og alle, der søger inspiration. Nyd liveoptrædener, interaktive sessioner og en livlig atmosfære. Gå ikke glip af denne unikke fejring af musik og rejser. Book dine billetter nu, og lad rejsen begynde!.",
//         price_override_text: '',
//         single_sign_on_price_override_text: '',
//       },
//       'en': {
//         info1: 'Melodies Across the Globe',
//         info2: 'MORE Embark on a musical journey that spans continents, blending the rhythms of travel with the harmony of song',
//         remarks: "Stand-up with Liam O'Connor. Duration: 50 minutes.",
//         description: `Join us for an unforgettable evening where music meets adventure. "Melodies Across the Globe" brings together world-class musicians and singers to celebrate the spirit of travel through song. From the bustling streets of New York to the serene landscapes of Kyoto, experience a symphony of cultures and sounds. Let the melodies transport you to faraway lands, igniting your wanderlust and love for music. This event is perfect for travelers, music lovers, and anyone seeking inspiration. Enjoy live performances, interactive sessions, and a vibrant atmosphere. Don’t miss this unique celebration of music and travel. Book your tickets now and let the journey begin!`,
//         price_override_text: '',
//         single_sign_on_price_override_text: '',
//       }
//     },
//     price_override_active: false,
//     price_override_text: '',
//     promoted: false,
//     saleend: randomFutureTimestamp(1, 30),
//     saleend_gmt_offset: 0,
//     salestart: 0,
//     salestart_gmt_offset: 0,
//     single_sign_on_price_override_active: false,
//     single_sign_on_price_override_text: '',
//     few_tickets: false,
//     soldout: false,
//     sort_order: 0,
//     special_categories: [],
//     sso_prices: {},
//     status_message_text: '',
//     status_message_visible: false,
//     tickets: [],
//     tz_name: ''
//   },
//   {
//     id: 17,
//     info1: 'Summer Nights Music Festival',
//     info2: 'MORE Oplev magien ved livemusik under stjernerne!', // required
//     photo: '/images/Example_event_photos/billetshop6.jpg',
//     remarks: 'Gentagelse af Summer Nights Music Festival koncerten. Varighed: 75 minutter.',
//     price: 750,
//     priceBefore: undefined,
//     currency: 'DKK',
//     eventtime: randomFutureTimestamp(1, 30),
//     eventtime_gmt_offset: 0,
//     eventtime_override: undefined,
//     dateRange: undefined,
//     organizer: 'Kulturhuset Skanderborg',
//     categories: [4, 2, 1],
//     venue: 5,
//     aggregated_categories_event_order: null,
//     aggregated_special_categories_event_order: false,
//     extra_photos: ['/images/Example_event_photos/billetshop4.jpg', '/images/Example_event_photos/billetshop5.jpg'],
//     video_url: 'https://www.youtube.com/watch?v=OPf0YbXqDm0',
//     remaining_tickets: 40,
//     description: `<p>En ekstra mulighed for at opleve Summer Nights Music Festival. Musikalsk oplevelse med både klassiske og moderne elementer.</p>
//       <ul>
//         <li>75 minutters koncert</li>
//         <li>Elektroniske og klassiske elementer</li>
//         <li>Ensemblet består af prisvindende musikere</li>
//         <li>Join us for an unforgettable evening at the Summer Nights Music Festival, where the best of live music meets the beauty of the great outdoors. Set in a picturesque open-air venue, this event features performances by top artists across genres, from rock to jazz. Bring your friends, family, and a picnic blanket to enjoy the vibrant atmosphere. With food trucks, craft beer, and activities for all ages, it’s the perfect way to celebrate summer. Don’t miss the chance to dance, sing, and create memories under the night sky. Tickets are limited, so book yours today!</li>
//       </ul>`,
//     element_type: '',
//     language: 'da',
//     languages: ['da', 'en'],
//     localizations: {
//       'da': {
//         info1: 'Summer Nights Music Festival',
//         info2: 'MORE Oplev magien ved livemusik under stjernerne!',
//         remarks: 'Gentagelse af Summer Nights Music Festival koncerten. Varighed: 75 minutter.',
//         description: 'Join us for an unforgettable evening at the Summer Nights Music Festival, where the best of live music meets the beauty of the great outdoors. Set in a picturesque open-air venue, this event features performances by top artists across genres, from rock to jazz. Bring your friends, family, and a picnic blanket to enjoy the vibrant atmosphere. With food trucks, craft beer, and activities for all ages, it’s the perfect way to celebrate summer. Don’t miss the chance to dance, sing, and create memories under the night sky. Tickets are limited, so book yours today!',
//         price_override_text: '',
//         single_sign_on_price_override_text: '',
//       },
//       'en': {
//         info1: 'Summer Nights Music Festival',
//         info2: 'MORE Experience the magic of live music under the stars!',
//         remarks: 'Repetition of the Summer Nights Music Festival concert. Duration: 75 minutes.',
//         description: 'Kom med til en uforglemmelig aften på Sommeraftener Musikfestival, hvor den bedste livemusik møder naturens skønhed. I en idyllisk udendørs ramme kan du opleve topkunstnere fra forskellige genrer, lige fra rock til jazz. Tag venner, familie og et tæppe med for at nyde den livlige stemning. Med madboder, specialøl og aktiviteter for alle aldre er det den perfekte måde at fejre sommeren på. Gå ikke glip af chancen for at danse, synge og skabe minder under nattehimlen. Billetterne er begrænsede, så køb din i dag!',
//         price_override_text: '',
//         single_sign_on_price_override_text: '',
//       }
//     },
//     price_override_active: false,
//     price_override_text: '',
//     promoted: false,
//     saleend: randomFutureTimestamp(1, 30),
//     saleend_gmt_offset: 0,
//     salestart: 0,
//     salestart_gmt_offset: 0,
//     single_sign_on_price_override_active: false,
//     single_sign_on_price_override_text: '',
//     few_tickets: false,
//     soldout: false,
//     sort_order: 0,
//     special_categories: [],
//     sso_prices: {},
//     status_message_text: '',
//     status_message_visible: false,
//     tickets: [],
//     tz_name: ''
//   },
//   {
//     id: 18,
//     info1: 'Dyrelivets Vidundere: En Rejse på Tværs af Kontinenter',
//     info2: 'MORE Tag med på en uforglemmelig rejse og udforsk verdens mest fascinerende dyr og deres levesteder', // required
//     photo: '/images/Example_event_photos/billetshop7.jpg',
//     remarks: 'Afslutningskoncert for festivalen. Varighed: 75 minutter.',
//     price: 750,
//     priceBefore: undefined,
//     currency: 'DKK',
//     eventtime: randomFutureTimestamp(1, 30),
//     eventtime_gmt_offset: 0,
//     eventtime_override: undefined,
//     dateRange: undefined,
//     organizer: 'Kulturhuset Skanderborg',
//     categories: [4, 2, 1],
//     venue: 2,
//     aggregated_categories_event_order: null,
//     aggregated_special_categories_event_order: false,
//     extra_photos: ['/images/Example_event_photos/billetshop4.jpg', '/images/Example_event_photos/billetshop5.jpg'],
//     video_url: 'https://www.youtube.com/watch?v=RgKAFK5djSk',
//     remaining_tickets: 30,
//     description: `<p>Festivalens afslutningskoncert med Ratata. En musikalsk rejse gennem klassisk og elektronisk musik.</p>
//       <ul>
//         <li>75 minutters koncert</li>
//         <li>Elektroniske og klassiske elementer</li>
//         <li>Ensemblet består af prisvindende musikere</li>
//       </ul>`,
//     element_type: '',
//     language: 'da',
//     languages: ['da', 'en'],
//     localizations: {
//       'da': {
//         info1: 'Dyrelivets Vidundere: En Rejse på Tværs af Kontinenter',
//         info2: 'MORE Tag med på en uforglemmelig rejse og udforsk verdens mest fascinerende dyr og deres levesteder',
//         remarks: 'Afslutningskoncert for festivalen. Varighed: 75 minutter.',
//         description: 'Kom med til en ekstraordinær begivenhed, der tager dig på en rejse gennem dyrenes rige. Fra Afrikas savanne til Amazonas regnskov – oplev dyrelivets skønhed og mangfoldighed som aldrig før. Lær om majestætiske elefanter, legesyge delfiner og sky sneleoparder. Arrangementet byder på fantastiske visuelle oplevelser, ekspertoplæg og interaktive udstillinger, der bringer naturens vidundere tættere på dig. Perfekt for familier, dyreelskere og rejseentusiaster. Opdag, hvordan du kan bidrage til bevarelse af dyrelivet, mens du nyder en dag fyldt med inspiration og forundring. Gå ikke glip af denne mulighed for at komme tættere på naturen!',
//         price_override_text: '',
//         single_sign_on_price_override_text: '',
//       },
//       'en': {
//         info1: 'Wildlife Wonders: A Journey Across Continents',
//         info2: 'MORE Embark on an unforgettable adventure exploring the world\'s most fascinating animals and their habitats.',
//         remarks: 'Closing concert for the festival. Duration: 75 minutes.',
//         description: 'Join us for an extraordinary event that takes you on a journey through the animal kingdom. From the African savannah to the Amazon rainforest, experience the beauty and diversity of wildlife like never before. Learn about the majestic elephants, playful dolphins, and elusive snow leopards. This event combines stunning visuals, expert talks, and interactive exhibits to bring the wonders of nature closer to you. Perfect for families, animal lovers, and travel enthusiasts alike. Discover how you can contribute to wildlife conservation efforts while enjoying a day filled with inspiration and awe. Don\'t miss this chance to connect with the natural world!',
//         price_override_text: '',
//         single_sign_on_price_override_text: '',
//       }
//     },
//     price_override_active: false,
//     price_override_text: '',
//     promoted: false,
//     saleend: randomFutureTimestamp(1, 30),
//     saleend_gmt_offset: 0,
//     salestart: 0,
//     salestart_gmt_offset: 0,
//     single_sign_on_price_override_active: false,
//     single_sign_on_price_override_text: '',
//     few_tickets: false,
//     soldout: false,
//     sort_order: 0,
//     special_categories: [],
//     sso_prices: {},
//     status_message_text: '',
//     status_message_visible: false,
//     tickets: [],
//     tz_name: ''
//   },
//   {
//     id: 19,
//     info1: 'Harmoni under Stjernerne',
//     info2: 'MORE Oplev en uforglemmelig aften med musik og sang under åben himmel', // required
//     photo: '/images/Example_event_photos/billetshop8.jpg',
//     remarks: 'Fællessang for alle aldre. Varighed: 60 minutter.',
//     price: 750,
//     priceBefore: undefined,
//     currency: 'DKK',
//     eventtime: randomFutureTimestamp(1, 30),
//     eventtime_gmt_offset: 0,
//     eventtime_override: undefined,
//     dateRange: undefined,
//     organizer: 'Kulturhuset Skanderborg',
//     categories: [4, 2, 1],
//     venue: 3,
//     aggregated_categories_event_order: 0,
//     aggregated_special_categories_event_order: false,
//     extra_photos: ['/images/Example_event_photos/billetshop2.jpg', '/images/Example_event_photos/billetshop3.jpg'],
//     video_url: 'https://www.youtube.com/watch?v=2Vv-BfVoq4g',
//     remaining_tickets: 50,
//     description: `<p>Fællessang med Steen Hattesen byder på en hyggelig og stemningsfuld oplevelse for hele familien. Kom og syng med på kendte klassikere og nye sange.</p>
//       <ul>
//         <li>Fællesskab og glæde</li>
//         <li>Professionel pianist</li>
//         <li>Varighed: 60 minutter</li>
//       </ul>
//       <p>Alle er velkomne, uanset sangstemme!</p>`,
//     element_type: '',
//     language: 'da',
//     languages: ['da', 'en'],
//     localizations: {
//       'da': {
//         info1: 'Harmoni under Stjernerne',
//         'info2': 'MORE Oplev en uforglemmelig aften med musik og sang under åben himmel',
//         'remarks': 'Fællessang for alle aldre. Varighed: 60 minutter.',
//         'description': 'Kom med til "Harmoni under Stjernerne," en magisk koncert, der forener det bedste fra klassisk, pop og folkemusik. I en smuk udendørs ramme optræder verdensberømte kunstnere og lokale talenter med dine yndlingsmelodier. Føl rytmen, syng med, og lad musikken føre dig til en anden verden. Med betagende visuelle effekter og en varm, indbydende atmosfære er dette en begivenhed for musikelskere i alle aldre. Tag vennerne, familien eller kom alene og nyd en aften fyldt med harmoni, glæde og uforglemmelige minder. Gå ikke glip af denne spektakulære fejring af musik og sang!',
//         'price_override_text': '',
//         'single_sign_on_price_override_text': '',
//       },
//       'en': {
//         'info1': 'Harmony Under the Stars',
//         'info2': 'MORE Experience an unforgettable evening of music and song beneath the open sky ',
//         'remarks': 'Community singing for all ages. Duration: 60 minutes.',
//         'description': 'Join us for "Harmony Under the Stars," a magical concert that brings together the best of classical, pop, and folk music. Set in a stunning outdoor venue, this event features world-renowned artists and local talents performing your favorite melodies. Feel the rhythm, sing along, and let the music transport you to another world. With breathtaking visuals and a warm, welcoming atmosphere, this is an event for music lovers of all ages. Bring your friends, family, or come solo to enjoy a night of harmony, joy, and unforgettable memories. Don\'t miss out on this spectacular celebration of music and song!',
//         price_override_text: '',
//         single_sign_on_price_override_text: '',
//       }
//     },
//     price_override_active: false,
//     price_override_text: '',
//     promoted: false,
//     saleend: randomFutureTimestamp(1, 30),
//     saleend_gmt_offset: 0,
//     salestart: 0,
//     salestart_gmt_offset: 0,
//     single_sign_on_price_override_active: false,
//     single_sign_on_price_override_text: '',
//     few_tickets: false,
//     soldout: false,
//     sort_order: 1,
//     special_categories: [],
//     sso_prices: {},
//     status_message_text: '',
//     status_message_visible: false,
//     tickets: [],
//     tz_name: ''
//   },
//   {
//     id: 20,
//     info1: 'MORE Skak for alle',
//     info2: 'TEASER MORE Skak for alle', // required
//     photo: '/images/Example_event_photos/billetshop9.jpg',
//     remarks: 'Skakturnering for alle niveauer. Varighed: 120 minutter.',
//     price: 750,
//     priceBefore: undefined,
//     currency: 'DKK',
//     eventtime: randomFutureTimestamp(1, 30),
//     eventtime_gmt_offset: 0,
//     eventtime_override: undefined,
//     dateRange: undefined,
//     organizer: 'Kulturhuset Skanderborg',
//     categories: [4, 2, 1],
//     venue: 4,
//     aggregated_categories_event_order: null,
//     aggregated_special_categories_event_order: false,
//     extra_photos: ['/images/Example_event_photos/billetshop1.jpg', '/images/Example_event_photos/billetshop2.jpg'],
//     video_url: 'https://www.youtube.com/watch?v=E7wJTI-1dvQ',
//     remaining_tickets: 100,
//     description: `<p>Skak for alle er en turnering, hvor både begyndere og øvede kan deltage. Kom og oplev spændingen ved skakspillet!</p>
//       <ul>
//         <li>120 minutters turnering</li>
//         <li>Præmier til vinderne</li>
//         <li>Alle niveauer er velkomne</li>
//       </ul>`,
//     element_type: '',
//     language: 'da',
//     languages: ['da', 'en'],
//     localizations: {
//       'da': {
//         'info1': 'MORE Skak for alle',
//         'info2': 'TEASER MORE Skak for alle',
//         'remarks': 'Skakturnering for alle niveauer. Varighed: 120 minutter.',
//         'description': 'Med Rumpistol i salen alle med synth og sandstem en undergrunde række mellem klassisk, jazz og elektronisk...',
//         'price_override_text': '',
//         'single_sign_on_price_override_text': '',
//       },
//       'en': {
//         'info1': 'MORE Chess for everyone',
//         'info2': 'TEASER MORE Chess for everyone',
//         'remarks': 'Chess tournament for all levels. Duration: 120 minutes.',
//         'description': 'With Rumpistol in the hall, everyone with synth and sand voice an underground row between classical, jazz, and electronic music...',
//         'price_override_text': '',
//         'single_sign_on_price_override_text': '',
//       }
//     },
//     price_override_active: false,
//     price_override_text: '',
//     promoted: false,
//     saleend: randomFutureTimestamp(1, 30),
//     saleend_gmt_offset: 0,
//     salestart: 0,
//     salestart_gmt_offset: 0,
//     single_sign_on_price_override_active: false,
//     single_sign_on_price_override_text: '',
//     few_tickets: false,
//     soldout: false,
//     sort_order: 0,
//     special_categories: [],
//     sso_prices: {},
//     status_message_text: '',
//     status_message_visible: false,
//     tickets: [],
//     tz_name: ''
//   },
//   {
//     id: 21,
//     info1: 'Only english localization',
//     info2: 'Only english event', // required
//     photo: '/images/Example_event_photos/billetshop9.jpg',
//     remarks: 'Skakturnering for alle niveauer. Varighed: 120 minutter.',
//     price: 750,
//     priceBefore: undefined,
//     currency: 'DKK',
//     eventtime: randomFutureTimestamp(1, 30),
//     eventtime_gmt_offset: 0,
//     eventtime_override: undefined,
//     dateRange: undefined,
//     organizer: 'Kulturhuset Skanderborg',
//     categories: [4, 2, 1],
//     venue: 4,
//     aggregated_categories_event_order: null,
//     aggregated_special_categories_event_order: false,
//     extra_photos: ['/images/Example_event_photos/billetshop1.jpg', '/images/Example_event_photos/billetshop2.jpg'],
//     video_url: 'https://www.youtube.com/watch?v=E7wJTI-1dvQ',
//     remaining_tickets: 100,
//     description: `<p>Skak for alle er en turnering, hvor både begyndere og øvede kan deltage. Kom og oplev spændingen ved skakspillet!</p>
//       <ul>
//         <li>120 minutters turnering</li>
//         <li>Præmier til vinderne</li>
//         <li>Alle niveauer er velkomne</li>
//       </ul>`,
//     element_type: '',
//     language: 'da',
//     languages: ['en'],
//     localizations: {
//       'en': {
//         'info1': 'Only english localization',
//         'info2': 'Only english event',
//         'remarks': 'Only english localization.',
//         'description': 'Only english localization',
//         'price_override_text': '',
//         'single_sign_on_price_override_text': '',
//       }
//     },
//     price_override_active: false,
//     price_override_text: '',
//     promoted: false,
//     saleend: randomFutureTimestamp(1, 30),
//     saleend_gmt_offset: 0,
//     salestart: 0,
//     salestart_gmt_offset: 0,
//     single_sign_on_price_override_active: false,
//     single_sign_on_price_override_text: '',
//     few_tickets: false,
//     soldout: false,
//     sort_order: 0,
//     special_categories: [],
//     sso_prices: {},
//     status_message_text: '',
//     status_message_visible: false,
//     tickets: [],
//     tz_name: ''
//   },
];

export const emptyEventItem: EventItem = {
  id: 0,
  info1: '',
  info2: '', // required
  photo: '',
  remarks: '', // optional
  price: 0,
  priceBefore: undefined,
  currency: 'DKK',
  eventtime: 0,
  eventtime_gmt_offset: 0,
  eventtime_override: null,
  dateRange: undefined,
  organizer: '',
  // extra_photos: [],
  // video_url: undefined,
  remaining_tickets: 0,
  description: '',
  element_type: '',
  language: '',
  languages: [],
  localizations: {
      'da': {
        'info1': "",
        'info2': "",
        'remarks': "",
        'description': "",
        'price_override_text': "",
        'single_sign_on_price_override_text': "",
      },
      'en': {
        'info1': "",
        'info2': "",
        'remarks': "",
        'description': "",
        'price_override_text': "",
        'single_sign_on_price_override_text': "",
      }
    },
  price_override_active: false,
  price_override_text: '',
  promoted: false,
  saleend: randomFutureTimestamp(1, 30),
  saleend_gmt_offset: 0,
  salestart: 0,
  salestart_gmt_offset: 0,
  single_sign_on_price_override_active: false,
  single_sign_on_price_override_text: '',
  few_tickets: false,
  soldout: false,
  sort_order: 0,
  special_categories: [],
  sso_prices: {},
  status_message_text: '',
  status_message_visible: false,
  tickets: [],
  tz_name: ''
};

export const categoryItems: Category[] = [
  {
    id: 1,
    name: "Dyre relateret",
    language: "da",
    languages: ["en", "da"],
    localizations: {
      da: { name: "Dyre relateret" },
      en: { name: "Animal related" },
    },
    num_events: 42,
    promoted: false,
    short_url: "dyr",
    hide_from_list: false,
    extlink: null,
    category_sort_event: [],
  },
  {
    id: 2,
    name: "Koncert",
    language: "da",
    languages: ["da", "en"],
    localizations: {
      da: { name: "Koncert" },
      en: { name: "Concert" },
    },
    num_events: 1,
    promoted: false,
    short_url: null,
    hide_from_list: false,
    extlink: null,
    category_sort_event: [{
      event_id: 10,
      sort_order: 0,
      category_id: 6,
    },
    {
      event_id: 11,
      sort_order: 1,
      category_id: 6,
    }],
  },
  {
    id: 3,
    name: "Literatur",
    language: "da",
    languages: ["en", "da"],
    localizations: {
      da: { name: "Literatur" },
      en: { name: "Literature" },
    },
    num_events: 1,
    promoted: false,
    short_url: "bower",
    hide_from_list: false,
    extlink: null,
    category_sort_event: [],
  },
  {
    id: 4,
    name: "Musik & sang",
    language: "da",
    languages: ["da"],
    localizations: {
      da: { name: "Musik & sang" },
    },
    num_events: 33,
    promoted: false,
    short_url: "flimmer",
    hide_from_list: false,
    extlink: null,
    category_sort_event: [],
  },
  {
    id: 5,
    name: "Rejser",
    language: "da",
    languages: ["da", "en"],
    localizations: {
      da: { name: "Rejser" },
      en: { name: "Travels" },
    },
    num_events: 44,
    promoted: false,
    short_url: "rejer",
    hide_from_list: false,
    extlink: null,
    category_sort_event: [],
  },
  {
    id: 6,
    name: "Udendørs",
    language: "da",
    languages: ["da", "en"],
    localizations: {
      da: { name: "Udendørs" },
      en: { name: "Outdoors" },
    },
    num_events: 45,
    promoted: false,
    short_url: null,
    hide_from_list: false,
    extlink: null,
    category_sort_event: [{
      event_id: 14,
      sort_order: 0,
      category_id: 6,
    },
    {
      event_id: 12,
      sort_order: 1,
      category_id: 6,
    }],
  },
];

export const venueItems: Venue[] = [
  {
    address: "Sletvej 2",
    address2: "-",
    city: "Tranbjer J",
    country: "Denmark",
    email: "",
    id: 1,
    lat_lng: "56.10509,10.14492",
    name: "Safeticket HQ",
    num_events: 2,
    telephone: "",
    website: "",
    zip: "8310",
  },
  {
    address: "Feiteira 1",
    address2: "",
    city: "Santa Cruz da Graciosa",
    country: "Graciosa",
    email: "",
    id: 2,
    lat_lng: "39.0862753,-28.015681099999995",
    name: "Tilfældigt sted i Atlanterhavet",
    num_events: 2,
    telephone: "49814651",
    website: "",
    zip: "4264",
  },
  {
    address: "Sletvej 2",
    address2: "",
    city: "Tranbjerg J",
    country: "Danmark",
    email: "jakob@safeticket.dk",
    id: 3,
    lat_lng: "56.104475,10.145397",
    name: "Kulturhuset Skanderborg",
    num_events: 2,
    telephone: "66666666",
    website: "",
    zip: "8310",
  },
  {
    address: "Kystpromenaden 7",
    address2: "",
    city: "Aarhus C",
    country: "Danmark",
    email: "",
    id: 4,
    lat_lng: "56.17111311165439,10.230738145989847",
    name: "Århus havn",
    num_events: 2,
    telephone: "",
    website: "",
    zip: "8000",
  },
  {
    address: "M.P. Bruuns Gade 25",
    address2: "",
    city: "Aarhus C",
    country: "Danmark",
    email: "",
    id: 5,
    lat_lng: "56.149231,10.203426",
    name: "Jernbane Museum",
    num_events: 2,
    telephone: "",
    website: "",
    zip: "8000",
  },
  {
    address: "Sletvej 2",
    address2: "-",
    city: "Tranbjer J",
    country: "Denmark",
    email: "",
    id: 6,
    lat_lng: "56.10509,10.14492",
    name: "SLET MIG",
    num_events: 0,
    telephone: "",
    website: "",
    zip: "8310",
  },
];

const customFields: CustomField[] = [
  {
    name: "testfelt",
    description: "Dette er et testfelt",
    long_description: "Dette er en længere beskrivelse af testfeltet.",
    checkbox: false,
    must_be_checked: false,
    cprnumber: '',
    text_large: false,
    datefield: false,
    fieldlist: 0,
    minDate: 0,
    maxDate: 0,
    empty_ok: false,
    char_limit: 0,
    only_numbers: false,
    event_id: undefined,
    tickets: undefined
  },
  {
    name: "testfelt2",
    description: "Dette er et testfelt",
    long_description: "Dette er en længere beskrivelse af testfeltet.",
    checkbox: false,
    must_be_checked: false,
    cprnumber: '',
    text_large: false,
    datefield: false,
    fieldlist: 0,
    minDate: 0,
    maxDate: 0,
    empty_ok: false,
    char_limit: 0,
    only_numbers: false,
    event_id: undefined,
    tickets: undefined
  },
];

export const localiseItem: TicketLocalizationLanguageCheckoutData = {
    name1: 'Test billet',
    name2: 'Test billet 2',
    remarks_ticket: 'Test billet bemærkninger',
};
export const localiseItemList: TicketLocalizationCheckoutData = {
    'da':  localiseItem,
};

export const ticketItems: Ticket[] = [
  {
    id: 1,
    name1: 'Løb',
    description: 'Løbetur til 6K Social Run med MK Running i København',
    price: 200,
    ticketfee: 7.5,
    count: 0,
    currency: 'DKK',
    tags: ['Siddeplads'],
    customFields,
    min_price: 0,
    max_price: 0,
    price_groups: [],
    vd_price: 0,
    vd_min_price: 0,
    vd_max_price: 0,
    vd_price_groups: [],
    volume_discount: undefined,
    ticketfee_extra: 0,
    hide_ticketfee_extra: false,
    shippingfee: 0,
    is_mobile_pay_okay: false,
    sso_price_warning: null,
    upsale_flag: false,
    upsale_name: '',
    upsale_title: '',
    upsale_description: '',
    upsale_allowed_tickets: [],
    upsale_banned_tickets: [],
    upsale_available_tickets: [],
    localizations: localiseItemList
  },
  {
    id: 2,
    label: 'VIPRUNNING',
    name1: 'Vip-billet',
    description: 'VIP til 6K Social Run med MK Running i København',
    discountText: 'VELKOMMEN10 (-100 kr)',
    price: 100,
    beforePrice: 150,
    count: 0,
    activationCode: 'Rabatkode',
    ticketfee: 7.5,
    currency: 'DKK',
    tags: ['Siddeplads'],
    min_price: 0,
    max_price: 0,
    price_groups: [],
    vd_price: 0,
    vd_min_price: 0,
    vd_max_price: 0,
    vd_price_groups: [],
    volume_discount: undefined,
    ticketfee_extra: 0,
    hide_ticketfee_extra: false,
    shippingfee: 0,
    is_mobile_pay_okay: false,
    sso_price_warning: null,
    upsale_flag: false,
    upsale_name: '',
    upsale_title: '',
    upsale_description: '',
    upsale_allowed_tickets: [],
    upsale_banned_tickets: [],
    upsale_available_tickets: [],
    localizations: localiseItemList
  },
  {
    id: 3,
    name1: 'Walk',
    description: 'Gåtur til 6K Social Run med MK Running i København',
    price: 200,
    count: 0,
    ticketfee: 7.5,
    currency: 'DKK',
    tags: ['Siddeplads'],
    flexData: '5km, 10km, 15km, 20km, 25km, 30km, 5km, 10km, 15km, 20km, 25km, 30km',
    customFields: customFields,
    min_price: 0,
    max_price: 0,
    price_groups: [],
    vd_price: 0,
    vd_min_price: 0,
    vd_max_price: 0,
    vd_price_groups: [],
    volume_discount: undefined,
    ticketfee_extra: 0,
    hide_ticketfee_extra: false,
    shippingfee: 0,
    is_mobile_pay_okay: false,
    sso_price_warning: null,
    upsale_flag: false,
    upsale_name: '',
    upsale_title: '',
    upsale_description: '',
    upsale_allowed_tickets: [],
    upsale_banned_tickets: [],
    upsale_available_tickets: [],
    localizations: localiseItemList
  },
];

export const ticketItems2: TicketCheckoutData[] = [
  {
    id: 1,
    name1: 'Test billet',
    name2: 'Test billet 2',
    localizations:  localiseItemList,
    mintickets: 1,
    maxtickets: 5,
    available: 100,
    price: 200,
    min_price: 200,
    max_price: 200,
    price_groups: [],
    type: 'standard',
    section_name: 'Test sektion',
    ticketfee: 0,
    ticketfee_extra: 0,
    shippingfee: 0,
    venuemap_section_id: 0,
    seatmap: '',
    upsale_flag: false,
    upsale_name: '',
    upsale_title: '',
    upsale_description: '',
    upsale_allowed_tickets: [],
    upsale_banned_tickets: [],
    upsale_photo: '',
    buy_amount_increment: 1,
    volume_discount: undefined,
  },
  {
    id: 2,
    name1: 'Test billet 2',
    name2: 'Test billet 2',
    localizations:  localiseItemList,
    mintickets: 1,
    maxtickets: 5,
    available: 50,
    price: 300,
    min_price: 300,
    max_price: 300,
    price_groups: [],
    type: 'standard',
    section_name: 'Test sektion',
    ticketfee: 0,
    ticketfee_extra: 0,
    shippingfee: 0,
    venuemap_section_id: 0,
    seatmap: '',
    upsale_flag: false,
    upsale_name: '',
    upsale_title: '',
    upsale_description: '',
    upsale_allowed_tickets: [],
    upsale_banned_tickets: [],
    upsale_photo: '',
    buy_amount_increment: 1,
    volume_discount: undefined,
  },
];

export const localiseItemEvent: EventLocalizationLanguageData = {
    info1: 'Test event',
    voucher_code_description: 'Test event voucher code description',
	  voucher_code_add_description: 'Test event voucher code add description',
	  voucher_code_remove_description: 'Test event voucher code remove description',
	  voucher_code_error_description: 'Test event voucher code error description',
	  voucher_code_valid_description: 'Test event voucher code valid description',

};

export const addonItems: Addon[] = [
  {
    id: 1,
    name1: 'T-shirt',
    count: 0,
    price: 950,
    currency: 'DKK',
    description: 'En lækker t-shirt til løbeturen',
    image: '/images/addon.png',
    customFields,
    min_price: 0,
    max_price: 0,
    price_groups: [],
    vd_price: 0,
    vd_min_price: 0,
    vd_max_price: 0,
    vd_price_groups: [],
    volume_discount: undefined,
    ticketfee: 0,
    ticketfee_extra: 0,
    hide_ticketfee_extra: false,
    shippingfee: 0,
    is_mobile_pay_okay: false,
    sso_price_warning: null,
    upsale_flag: false,
    upsale_name: '',
    upsale_title: '',
    upsale_description: '',
    upsale_allowed_tickets: [],
    upsale_banned_tickets: [],
    upsale_available_tickets: [],
    localizations: localiseItemList
  },
  {
    id: 2,
    name1: 'Børne T-shirt',
    count: 0,
    price: 325,
    currency: 'DKK',
    description: 'En børnevenlig t-shirt til løbeturen',
    image: '/images/addon.png',
    min_price: 0,
    max_price: 0,
    price_groups: [],
    vd_price: 0,
    vd_min_price: 0,
    vd_max_price: 0,
    vd_price_groups: [],
    volume_discount: undefined,
    ticketfee: 0,
    ticketfee_extra: 0,
    hide_ticketfee_extra: false,
    shippingfee: 0,
    is_mobile_pay_okay: false,
    sso_price_warning: null,
    upsale_flag: false,
    upsale_name: '',
    upsale_title: '',
    upsale_description: '',
    upsale_allowed_tickets: [],
    upsale_banned_tickets: [],
    upsale_available_tickets: [],
    localizations: localiseItemList
  },
];

export const vatItem: vat = {
  cardfee: 25,
  ticketprice: 25,
  shippingfee: 25,
  ticketfee: 25,
};


export const defaultCartItems: CartItem[] = [
  {
    id: 1,
    name: '6K Social Run med MK Running i København',
    currency: 'DKK',
    vat: vatItem,
    giftcard_allowed: true,
    localizations: { da: localiseItemEvent },
    date: 'Lør. 28 jun kl. 09:30',
    venueName: 'CopenHill, Vindmøllevej 6, 2300 København S',
    image: '/images/cart-1.jpg',
    tickets: [],
    addons: [],
    itemTimestamp: 0,
    itemTimestampOverride: null
  },
  {
    id: 2,
    name: 'Aarhus City Halvmarathon 2026',
    currency: 'DKK',
    vat: vatItem,
    giftcard_allowed: true,
    localizations: { da: localiseItemEvent },
    date: 'Lør. 28 jun kl. 09:30',
    venueName: 'CopenHill, Vindmøllevej 6, 2300 København S',
    image: '/images/cart-1.jpg',
    tickets: ticketItems,
    addons: [],
    itemTimestamp: 0,
    itemTimestampOverride: null
  },
];

export const discountCodes = [{ code: 'Rabatkode', discount: 500 }];
export const giftCodes = [{ code: 'Gavekortkode', discount: 500 }];

export const checkoutStatus = {
  text: '',
  // text: 'Vi oplever problemer med betalingsgateway',
  link: 'https://safeticket.dk/status',
  linkText: 'Se status',
};

export const logo = {
  src: '/images/paletten.png',
  alt: 'Paletten',
};

export const footer = {
  company: 'Safeticket text A/S',
  address: 'Gunnar Clausens Vej 42, 0123 Viby',
  menus: [
    {
      title: 'Billetkøber',
      links: [
        { name: 'Mister du billet?', url: '/lost-ticket' },
        { name: 'Anvend gavekort', url: '/redeem-gift-card' },
        { name: 'Annuller ordre', url: '/cancel-order' },
      ],
    },
    {
      title: 'Kontakt',
      links: [
        { name: 'Kontakt', url: '/contact' },
        { name: 'Betingelser', url: '/terms' },
        { name: 'Cookies', url: '/cookies' },
      ],
    },
  ],
  cta: {
    title: 'Afholder du events? – Få et gratis billetsystem',
    usps: ['Lavt gebyr til billetkøbere', 'Fri dansk support'],
    button: {
      text: 'Se mere',
      url: '#',
    },
  },
  logoFooter: {
    links: [
      { name: 'Arrangør login', url: '/organizer/login' },
      { name: 'Billetsystem', url: '/organizer/login' },
      { name: 'Tilmeldingssystem', url: '/organizer/login' },
    ],
  },
  bottomFooter: {
    links: [{ name: 'Arrangør login', url: '/organizer/login' }],
  },
};

export const totals: Totals = {
    total: 0,
    total_price: 0,
    total_vat: 0,
    total_ticketfee: 0,
    total_transaction_fee: 0,
    total_discount: 0,
};

export const emptyAPIReceipt: APIReceipt = {
    status: 'error',
    orderid: 0,
    mailid: '',
    fee: 0,
    currency: '',
    dankort_discount: 0,
    ts: 0,
    ts_gmt_offset: 0,
    transaction: '',
    cardnumber: '',
    info: {
        email: '',
        email2: '',
        name: '',
        address: '',
        address2: '',
        zip: '',
        city: '',
        telephone: '',
        country: '',
        newsletter: false,
        customcheckbox: false,
        vouchercodesavedata: false,
        mailshipping: false,
        giftcards: [],
        price_group_info: undefined,
        customfields_data: undefined,
    },
    giftcards: [],
    basket: [],
    passbook: {
        link: '',
        qr: '',
        atpblink: '',
    },
}

export const frontpage2SegmentItems: FrontpageSegment[] = [
  {
    id: 1,
    sort_order: 0,
    category_id: undefined,
    languages: ['da'],
    localizations: { da: { name: 'HOT LIGE NU' } },
    events: [1,3,5],
  },
  {
    id: 2,
    sort_order: 1,
    category_id: 4,
    languages: ['da'],
    localizations: { da: { name: 'Musik & sang' } },
    events: [2,4,6,8,16],
  },
  {
    id: 3,
    sort_order: 2,
    category_id: 5,
    languages: ['da', 'en'],
    localizations: { da: { name: 'Rejser' }, en: { name: 'Travel' } },
    events: [7,11,9],
  },
  {
    id: 4,
    sort_order: 3,
    category_id: undefined,
    languages: ['da'],
    localizations: { da: { name: 'Hemmelig' } },
    events: [],
  },
  {
    id: 5,
    sort_order: 4,
    category_id: 1,
    languages: ['da', 'en'],
    localizations: { da: { name: 'Dyre relateret' }, en: { name: 'Animal related' } },
    events: [15,2,],
  },
  {
    id: 6,
    sort_order: 5,
    category_id: 6,
    languages: ['da', 'en'],
    localizations: { da: { name: 'Udendørs' }, en: { name: 'Outdoor' } },
    events: [7],
  },
  {
    id: 7,
    sort_order: 6,
    category_id: undefined,
    languages: ['en'],
    localizations: { en: { name: 'Only english' } },
    events: [10,11,21],
  },
  {
    id: 8,
    sort_order: 7,
    category_id: undefined,
    languages: ['da'],
    localizations: { da: { name: 'Kun dansk' } },
    events: [21],
  },
];

export const languageItems = ['da', 'en'];

export const shortURLItems: Record<string, number> = {
  'mussan': 4,
  'rejer': 5,
};